<template>
  <base-page class="comp-page-device"
             :title="monitorList.showMonitor?$t('l.my_focus') +'-' + $t('l.device_monitor'):$t('l.device_manage')"
             :icon="monitorList.showMonitor?'md-star':'md-cube'">
    <Row slot="extra" type="flex" :justify="monitorList.showMonitor?'start':'end'">

      <!--      2025年7月17日   接入　有权限的同时必须得是主电梯厂　　-->
      <Col v-if="$ifauth('fun_push_setting') && $store.state.user.user.company.pid === 0" class="margin-left-5">
        <Button ghost type="primary" @click="openPusherConfig">
          {{ $t('l.pusher_config') }}
        </Button>
      </Col>
      <Col class="margin-left-5">
        <Button ghost type="primary" @click="batchPusherConfig">
          {{ $t('l.batch_set_config') }}
        </Button>
      </Col>
      <Col v-if="!monitorList.showMonitor" class="margin-left-5">
        <Button type="primary" @click="openMap">{{$t('l.map_location')}}</Button>
      </Col>
      <Col v-if="$ifauth('fun_device_add_like') && !monitorList.showMonitor" class="margin-left-5">
        <Button ghost type="primary"
                @click="toggleLikes">
          {{ $t('l.my_focus') }}
          <Badge v-if="!monitorList.showMonitor" :offset="[0,-4]" type="primary"
                 :count="monitorList.likes.length"></Badge>
        </Button>
      </Col>
      <Col v-if="$ifauth('fun_device_batch_import')&&!monitorList.showMonitor" class="margin-left-5">
        <Upload class="upload-button"
                :before-upload="beforeUploadFile"
                :action="uploadAddress"
                :on-error="(error)=>{console.log(error);$Message.destroy();$Message.error($t('l.upload_fail'));loading.upload = false;}"
                :show-upload-list="false"
                :on-format-error="()=>{$Message.warning($t('l.remark68'))}"
                :format="['csv','xlsx','xls']">
          <Button :loading="loading.upload" icon="ios-cloud-upload-outline" type="primary">{{ $t('l.batch_import') }}</Button>
        </Upload>
      </Col>
      <Col class="margin-left-5" v-if="$ifauth('fun_device_batch_import')&&!monitorList.showMonitor">
        <Button ghost type="primary"
                @click="openSetExcelExport">{{ $t('l.remark69') }}
        </Button>
      </Col>
      <template v-if="!monitorList.showMonitor">
        <Col class="margin-left-5">
          <Button type="primary" @click="otherModals.searchSelect=true">{{ $t('l.filter') }}</Button>
        </Col>
        <Col class="margin-left-5">
          <Button type="primary" :loading="exportDataLoading" @click="exportExcelOfResult">{{ $t("l.export") }}</Button>
        </Col>
        <Col v-if="batch.list.length" :class="batch.list.length?'margin-left-5':''">
          <Button ghost type="primary" @click="ifShowBatch=!ifShowBatch">
            {{ $t('l.batch_operation') }}
            <Badge :offset="[0,-4]" type="primary" :count="batch.list.length"></Badge>
          </Button>
        </Col>
        <!--                <res-view key-name="fun_device_add">-->
        <Col class="margin-left-5" v-if="$ifauth('fun_device_add')">
          <Button type="primary" @click="preAdd('modal_device')">{{ $t('l.add_device') }}</Button>
        </Col>
        <!--                </res-view>-->
        <Col v-if="$ifauth('fun_device_batch_update')" class="margin-left-5">
          <Button type="primary" @click="batchModal.show=true">
            {{ $t('l.batch_edit') }}
          </Button>
        </Col>
        <Col class="margin-left-5">
          <Button type="primary" @click="loadData(table.page.current, search)">
            {{ $t('l.fresh') }}
          </Button>
        </Col>
      </template>
      <Col v-if="!monitorList.showMonitor" class="margin-left-5">
        <Input class="search-keyword" style="width: 100%;" v-model="table.page.keyword" search
               :placeholder="$t('l.remark70')" @on-change="searchBlur" @on-search="loadData(1,search)"/>
        <Input hidden style="display:none"/>
      </Col>
    </Row>
    <template>
      <div>
        <!-- 返回设备列表 -->
        <Button class="margin-bottom-10" v-if="$ifauth('fun_device_add_like') && monitorList.showMonitor"
                @click="back_devices">
          <Icon type="ios-arrow-back"></Icon>
          {{ $t('l.back_devices') }}
        </Button>
        <!-- 筛选条 -->
        <search-bar v-if="!monitorList.showMonitor"
                    :search="search"
                    @on-search="onSearch"></search-bar>
        <!-- 视图切换 -->
        <div class="view-change-box">
          <div class="margin-right-10"><img @click="showTableData=false"
                                            :src="!showTableData?'/images/device/device-selected-icon.png':'/images/device/device-icon.png'"
                                            alt=""></div>
          <div><img @click="showTableData=true"
                    :src="!showTableData?'/images/device/table-icon.png':'/images/device/table-selected-icon.png'"
                    alt=""></div>
        </div>
        <template v-if="!showTableData">
          <!-- 图标视图 -->
          <lift-groups
              :community-map="communityMap"
              :deviceList="table.data"
              :showMonitor="monitorList.showMonitor"
              :likes="monitorList.likes"
              :page-num="table.page.current"
              @on-edit="preEdit"
              @on-like="preLike"
              @on-unlike="preUnlike"
              @delete="deleteDevice"
              @on-qrcode="getDeviceQrcode"
              @addBatch="addBatch">
          </lift-groups>
        </template>
        <!-- 图表视图 -->
        <template v-if="showTableData">
          <Table :data="table.data" :columns="table.columns"></Table>
        </template>
      </div>
      <Row type="flex" justify="center">
        <Col>
          <Page size="small"
                v-if="!monitorList.showMonitor"
                :current="table.page.current"
                :page-size="table.page.size"
                :total="table.page.total"
                :page-size-opts="table.page.sizeOptions"
                show-elevator show-sizer show-total
                @on-page-size-change="($event)=>{table.page.size = $event,loadData(1)}"
                @on-change="loadData($event,search)">
          </Page>
        </Col>
      </Row>
    </template>
    <!-- 筛选电梯 -->
    <template>

<!--      2025年10月28日  新增 天地图  -->
      <Drawer :title="$t('l.map_location')" :closable="false" :width="50" :draggable="true"
              v-model="mapDrawer.show" @on-visible-change="mapDrawerVisibleChange">
        <tian-map :show="mapDrawer.show" :center="mapDrawer.center" :is-add-marker="false" :pointList="mapDrawer.markers"></tian-map>
      </Drawer>

      <Drawer :title="$t('l.filter_lift')" :closable="false" :width="50" :draggable="true"
              v-model="otherModals.searchSelect">
        <search-modal :search="search" :searchLoading="searchLoading"  @selectedDate="selectedDate"></search-modal>
      </Drawer>
      <!-- 新增电梯 -->
      <lg-modal :width="1200" :title="modal.title" :show="modal.show" :loading="modal.loading"
                @on-submit="onSubmit('modal')"
                 :styles="{top:'20px'}"
                @on-cancel="modal.loading=false;modal.show = false;">
        <Form label-position="left" :rules="getRules" ref="modal" :model="modal"
              style="max-height: 700px; overflow-y: auto;overflow-x: hidden;">
          <!-- 设备类型 -->
          <FormItem v-if="!modal.device.id" :label-width="140" :label="$t('l.device_type')">
            <RadioGroup type="button" v-model="modal.device.type"
                        @on-change="changeRadio">
              <template v-for="t in search.type.values" v-if="t.isAuth&&t.show">
                <Radio :label="t.id" :key="t.id">
                  {{ t.name }}
                </Radio>
              </template>
            </RadioGroup>
          </FormItem>
          <!-- 名称 -->
          <FormItem :label-width="140" prop="device.name"
                    :label="modal.device.type == 0 ? $t('l.elevator_name'):$t('l.project_name')">
            <Input v-model="modal.device.name" :placeholder="$t('l.elevator_name')"/>
          </FormItem>
          <!-- 设备代码 -->
          <FormItem :label-width="140" :label="$t('l.equipment_code')">
            <Input v-model="modal.device.equipment_code"/>
            <Poptip transfer :title="$t('l.equipment_code')" placement="top">
              <img class="cursor-pointor margin-left-10"
                   src="/images/question-mark.svg" alt="">
              <div style="height: 300px;width: 500px;" slot="content">
                <p style="margin: 10px 0;font-size: 14px;white-space: initial;">
                  设备代码在电梯特种设备使用标志上可以查到，通常由管理部门颁发，通常该代码在18-22位不等。</p>
                <img style="width: 100%;height: 100%;" src="/images/device/explain-1.png" alt="">
              </div>
            </Poptip>
          </FormItem>
          <!-- 电梯编号\厂家代码 -->
          <FormItem :label-width="140" :label="isZhongFuCompany?$t('l.device_unique_id'):$t('l.device_number')">
            <Input v-model="modal.device.code" :placeholder="isZhongFuCompany?$t('l.device_unique_id'):$t('l.device_number')"/>
            <Poptip transfer title="出厂编号/厂家编号/厂家代码/唯一工号"
                    content="厂家代码为电梯厂内部给电梯定义的唯一代码，需要与在管理部门登记的信息一致" placement="top">
              <img class="cursor-pointor margin-left-10"
                   src="/images/question-mark.svg" alt="">
            </Poptip>
          </FormItem>

          <!--          2025年2月5日  王欢 补全威海质监局要求字段-->

          <!--          <FormItem  :label-width="140" :label="$t('l.variety')">-->
          <!--            <Select v-model="modal.device.variety" style="width:200px">-->
          <!--              <Option v-for="item in varietyList" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
          <!--            </Select>-->
          <!--          </FormItem>-->

          <!-- 2G版的 IMSI-->
          <FormItem v-if="modal.device.type === 4" :label-width="140" :label="$t('l.IMSI')">
            <Input v-model="modal.device_2g.IMSI"/>
          </FormItem>
          <!-- 终端ID -->
          <FormItem :label-width="140" :label="modal.device.type == 4?$t('l.BS'):$t('l.terminal_id')">
            <Input v-model="modal.device.terminal_id" :placeholder="$t('l.terminal_id')"/>
            <Poptip placement="top" transfer :title="$t('l.terminal_id')">
              <img class="cursor-pointor margin-left-10"
                   src="../../../public/images/question-mark.svg" alt="">
              <div style="height: 300px;width: 500px;" slot="content">
                <p style="margin: 10px 0;font-size: 14px;white-space: initial;">终端ID指的是我司数据采集终端WCR设备ID，在设备机身
                  外壳上可以找到，TWCR格式为“W_XXXXXXXXXXXXXX”，VWCR格式为“T_XXXXXXXXXXXXXX”，如图所示：</p>
                <img style="width: 100%;height: 100%;" src="/images/device/explain-4.jpg" alt="">
              </div>
            </Poptip>
          </FormItem>

          <!--                  2024年10月14日   王欢  新增m3u8 视频流格式字段  支持直接播放m3u8-->
          <FormItem :label-width="140" :label="$t('l.stream_m3u8')">
            <Input v-model="modal.device.stream_m3u8" :placeholder="$t('l.stream_m3u8') + '   '+'https://xxxx.m3u8'"/>
          </FormItem>

          <!-- 2G版的 得添加设备号 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140"
                    :rules="{required: true, message: $t('l.remark33'), trigger: 'blur'}"
                    prop="device_2g.DEVICE_NUM" :label="$t('l.device_num')">
            <Input v-model="modal.device_2g.DEVICE_NUM"/>
          </FormItem>

          <!-- 2G版的层站门 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140"
                    :rules="{required: true, message: $t('l.remark33'), trigger: 'blur'}"
                    prop="device_2g.FLOOR" :label="$t('l.floor_station_door')">
            <Input v-model="modal.device_2g.FLOOR"/>-<Input v-model="modal.device_2g.STATION"/>-<Input
              v-model="modal.device_2g.DOOR"/>
          </FormItem>
          <!-- 2g版的整梯出厂日期 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.leave_factory_date')">
            <DatePicker type="date" v-model="modal.device_2g.MANUFACTUREDATE"></DatePicker>
          </FormItem>
          <!-- 2g版的投用日期 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.throw_in_date')">
            <DatePicker type="date" v-model="modal.device_2g.USEDATE"></DatePicker>
          </FormItem>
          <!-- 2g版的下此年检日期 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.next_year_date')">
            <DatePicker type="date" v-model="modal.device_2g.XCNJRQ"></DatePicker>
          </FormItem>
          <!-- 是否交付 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.Delivery')">
            <RadioGroup v-model="modal.device_2g.Delivery">
              <Radio :label="1">
                <span>是</span>
              </Radio>
              <Radio :label="0">
                <span>否</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <!-- 2G版的 合同号-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.CONTRACT')">
            <Input v-model="modal.device_2g.CONTRACT"/>
          </FormItem>
          <!-- 2G版的 安装单位-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.INSTALLATION')">
            <Input v-model="modal.device_2g.INSTALLATION"/>
          </FormItem>
          <!-- 2G版的 安装责任人-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.INSTALLATIONMAN')">
            <Input v-model="modal.device_2g.INSTALLATIONMAN"/>
          </FormItem>
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.INSTALLATIONMANMOBILE')">
            <Input v-model="modal.device_2g.INSTALLATIONMANMOBILE"/>
          </FormItem>
          <!-- 2G版的 使用单位 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.CONSUMER')">
            <Select v-model="modal.device_2g.CONSUMER"></Select>
          </FormItem>
          <!-- 2G版的 使用场合 USEOCCASION-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.USEOCCASION')">
            <Input v-model="modal.device_2g.USEOCCASION"/>
          </FormItem>
          <!-- 2G版的 产权单位 OWNER-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.OWNER')">
            <Select v-model="modal.device_2g.OWNER"></Select>
          </FormItem>
          <!-- 2G版的 物业单位 PROPERTY -->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.PROPERTY')">
            <Select v-model="modal.device_2g.PROPERTY"></Select>
          </FormItem>
          <!--物业人员 WYRY-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.WYRY')">
            <Input v-model="modal.device_2g.WYRY"/>
          </FormItem>
          <!--物业人员电话 WYDH-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.WYDH')">
            <Input v-model="modal.device_2g.WYDH"/>
          </FormItem>
          <!--小区-->
          <FormItem v-if="modal.device.type != 4" :label-width="140" :label="$t('l.community')">
            <Row :gutter="5">
              <Col span="20">
                <Select :placeholder="$t('l.remark71')"
                        v-model="modal.device.community_id"
                        filterable
                        remote
                        ref="setQuery"
                        :remote-method="remoteSearchCommunity"
                        :loading="modal.searchLoading.community_id"
                        @on-change="onCommunitySelect">
                  <Option v-for="(comm) in search.community_id.values" :value="comm.id"
                          :key="comm.id">{{ comm.name }}
                  </Option>
                </Select>
              </Col>
              <Col span="2">
                <Button :title="$t('l.create_community')" @click="preJumpAddCommunity">+</Button>
              </Col>
            </Row>
          </FormItem>
          <!-- 如果是虚拟电梯 可以选择绑定真实电梯 -->
          <FormItem :label-width="140" v-if="modal.device.type==3" :label="$t('l.select_bound_lift')">
            <Select :placeholder="$t('l.select_bound_lift')"
                    filterable
                    remote
                    :remote-method="remoteSearchRealDevices"
                    @on-change="onRealDeviceSelect"
                    :loading="modal.searchLoading.real_devices"
                    v-model="modal.current_selected_terminal">
              <Option v-for="(item,index) in realDevices" :key="index"
                      :value="item.name+'【'+item.terminal_id+'】'">{{ item.name + "【" + item.terminal_id + "】" }}
              </Option>
            </Select>
          </FormItem>
          <FormItem :label-width="140" v-if="modal.device.type==3" :label="$t('l.virtual_lift_id')">
            <Input :disabled="true" v-model="modal.device.vm_device_id"
                   :placeholder="$t('l.virtual_lift_id')"/>
          </FormItem>
          <!--楼宇单元 -->
          <FormItem v-if="modal.device.type == 0" :label-width="140" :label="$t('l.build_unit')">
            <Cascader v-model="modal.choosedLocationIds"
                      :data="modal.locationTree"
                      change-on-select
                      @on-change="onLocationSelect"
                      :placeholder="$t('l.remark74')">
            </Cascader>
          </FormItem>
          <FormItem :label-width="125" v-if="modal.device.type!=3" :label="$t('l.get_coordinates')">
            <span class="text-font-size margin-right-5">{{ $t('l.longitude') }}</span>
            <InputNumber style="width: 100px" v-model="modal.device.longitude"
                         type="number"/>
            <span class="text-font-size margin-left-10 margin-right-5">{{ $t('l.latitude') }}</span>
            <InputNumber style="width: 100px" v-model="modal.device.latitude"
                         type="number"/>
            <Button size="small"  class="margin-left-10" @click="clickSelectLocation">
              {{ $t('l.select_location') }}
            </Button>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.detail_address')">
            <Input type="textarea" v-model="modal.device.address" :placeholder="$t('l.remark75')"></Input>
          </FormItem>

          <!--          <FormItem style="display: flex;align-items: center" v-if="$ifauth('device_controls')"-->
          <!--                    :label="$t('l.remote_controls')">-->
          <!--            <i-switch v-model="modal.device.is_remote_controls"></i-switch>-->
          <!--          </FormItem>-->

          <FormItem v-if="modal.device.type == 0" class="extra-form-item" prop="totalFloor" :label-width="100"
                    :label="$t('l.total_floor') + ' ' + (modal.device.j_floors.negative + modal.device.j_floors.positive)">
            <input type="hidden" :value="modal.totalFloor" :disabled="modal.device.type==3"/>
            <span class="text-font-size margin-right-5">{{ $t('l.positive_floor') }}</span>
            <InputNumber type="number" v-model="modal.device.j_floors.positive"
                         :disabled="modal.device.type==3" :min="0"
                         :max="(modal.device.device_param.is_through_door?32:64) - modal.device.j_floors.negative"
                         @on-change="onTotalFloorChange($event, 1)"/>
            <span class="text-font-size margin-right-5 margin-left-10">{{ $t('l.negative_floor') }}</span>
            <InputNumber :disabled="modal.device.type==3" type="number"
                         v-model="modal.device.j_floors.negative" :min="0"
                         :max="(modal.device.device_param.is_through_door?32:64) - modal.device.j_floors.positive"
                         @on-change="onTotalFloorChange($event, -1)"/>
            <Poptip transfer
                    :title="$t('l.floor_editor') + (modal.device.device_param.is_through_door?'(' + $t('l.through_door') + ')':'')"
                    placement="bottom" ref="floor_editor">
              <Button class="margin-left-10" @click.self="modal.showFloorEditor=true;" icon="md-options">
                {{ $t('l.floor_editor') }}
              </Button>
              <Poptip word-wrap :width="300" :content="$t('l.explain10')" transfer>
                <img class="cursor-pointor margin-left-10"
                     src="/images/question-mark.svg" alt="">
              </Poptip>
              <floor-editor :floors="modal.device.j_floors"
                            :positive="modal.device.j_floors.positive"
                            :negative="modal.device.j_floors.negative"
                            :is-through-door="modal.device.device_param.is_through_door"
                            slot="content"
                            @on-close="$refs.floor_editor.handleClose()"></floor-editor>
            </Poptip>
            <span style="margin: 0 10px">
                                <span class="text-font-size margin-right-5"
                                      style="display: inline-flex;align-items: center">{{ $t('l.through_door') }}</span>
                                    <i-switch @on-change="switch_change_through"
                                              v-model="modal.device.device_param.is_through_door" :false-value="0"
                                              :true-value="1" ref="switch_change_through"
                                              size="large">
                                        <span slot="open">{{ $t('l.open') }}</span>
                                        <span slot="close">{{ $t('l.close') }}</span>
                                    </i-switch>
                                </span>
            <span style="margin: 0 10px">
                                <span class="text-font-size margin-right-5"
                                      style="display: inline-flex;align-items: center">{{ $t('l.manual_door') }}</span>
                                    <i-switch v-model="modal.device.device_param.manual_door" :false-value="0"
                                              :true-value="1"
                                              size="large">
                                        <span slot="open">{{ $t('l.open') }}</span>
                                        <span slot="close">{{ $t('l.close') }}</span>
                                    </i-switch>
                                </span>
            <Poptip word-wrap :width="300" :content="$t('l.explain17')" transfer>
              <img class="cursor-pointor margin-left-10"
                   src="/images/question-mark.svg" alt="">
            </Poptip>
          </FormItem>

          <FormItem :label-width="140" :label="$t('l.doors')">
            <InputNumber :max="64" :min="1" :step="1" v-model="modal.device.doors"/>
          </FormItem>
          <FormItem v-if="modal.device.type == 0" :label-width="140" :label="$t('l.face')">
            <Input v-model="modal.device.face_id" :placeholder="$t('l.face_terminal_id')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.brand')">
            <Input v-model="modal.device.brand" :placeholder="$t('l.brand')"/>
          </FormItem>
<!--          <p v-if="modal.device.type == 0" class="explain margin-left-0">注：{{ $t('l.explain11') }}</p>-->
          <FormItem v-if="$store.state.user.isROOT" :label-width="140" :label="$t('l.manufacturer')">
            <Select :placeholder="$t('l.select_manufacturer2')"
                    v-model="modal.device.factory_cid"
                    filterable
                    remote
                    :loading="modal.searchLoading.factory"
                    @on-select="remoteSearchFactoryBranch('', 'replace')">
              <Option v-for="(factory) in search.factory_cid.values" :value="factory.id"
                      :key="factory.id">{{ factory.name }}
              </Option>
            </Select>
          </FormItem>
          <p v-if="modal.device.type == 0 && $store.state.user.isROOT" class="explain margin-left-0">
            {{ $t('l.warn_note') }}：{{ $t('l.explain12') }}</p>
          <FormItem :label-width="140" :label="$t('l.manufacturer_branch')"
                    v-if="modal.device.factory_cid>0 && modal.device.type == 0">
            <Select :placeholder="$t('l.remark82')"
                    v-model="modal.device.factory_branch"
                    filterable
                    remote
                    :remote-method="remoteSearchFactoryBranch"
                    :loading="modal.searchLoading.factoryBranch">
              <Option v-for="(factory) in search.factory_branch.values" :value="factory.id"
                      :key="factory.id">{{ factory.name }}
              </Option>
            </Select>
          </FormItem>
          <p v-if="modal.device.factory_cid>0 && modal.device.type == 0" class="explain margin-left-0">
            注：{{ $t('l.explain13') }}</p>

          <!-- 推送方式 -->
          <FormItem v-if="modal.device.type == 0 && showpush" :label-width="140"
                    :label="$t('l.select_push_city')">


            <!--            <RadioGroup @on-change="chooseRadio" v-model="modal.device.regulatory_field.way">-->
            <!--              &lt;!&ndash;  推送  参数说明 、 获取推送列表请求参数&ndash;&gt;-->
            <!--              <Radio label=""><span>{{ $t('l.none') }}</span></Radio>-->
            <!--              <Radio v-for="(elem) in modal.push_way" :label="elem.label" :key="elem.label">-->
            <!--                <span>{{ elem.name }}</span>-->
            <!--              </Radio>-->
            <!--            </RadioGroup>-->


            <!--            2025年7月21日  改为下拉框单选-->
            <Select @on-select="chooseSelect" v-model="modal.device.push_scheme_code" style="width:200px">
              <Option value="" key="">{{ $t("l.none") }}</Option>
              <Option v-for="item in pusherModal.schemeConfigList" :value="item.code" :key="item.code">
                {{ item.name }}
              </Option>
            </Select>

            <span class="push-file-box">
              <a class="margin-left-10" v-for="fileItem in pusherModal.currentPusherFile" :href="fileItem.url"
                 style="color: #39f">{{ fileItem.name }}</a>
            </span>

          </FormItem>
          <div class="filed-list" v-if="showPushFiled">
            <Divider>{{ $t("l.push_filed_setting") }}</Divider>
          </div>
          <!--          <Row v-if="showPushFiled">-->
          <!--            <p style="font-weight: bold">{{ $t("l.describe") }}:</p>-->
          <!--            <pre style="color: #A9B0B4">{{ modal.current_describe ? modal.current_describe : '未设置' }}</pre>-->
          <!--          </Row>-->
          <div v-for="(lt,i) in modal.filed_list" :key="i">
            <FormItem :label-width="200" :label="lt.explain">
              <Input :placeholder="$t('l.remark73')+lt.explain"
                     v-model="modal.device.regulatory_field[lt.filed]"/>
              <!--              <template v-if="lt.filed=='monitorCode'">-->
              <!--                <Poptip transfer :title="lt.explain" placement="top">-->
              <!--                  <img class="cursor-pointor margin-left-10"-->
              <!--                       src="/images/question-mark.svg" alt="">-->
              <!--                  <div style="height: 300px;width: 500px;" slot="content">-->
              <!--                    <p style="margin: 10px 0;font-size: 14px;white-space: initial">-->
              <!--                      部分地区监管平台会额外提供一个设备监察码(或设备识别码-->
              <!--                      等)，通常该代码6-10位左右。-->
              <!--                    </p>-->
              <!--                    <img style="width: 100%;height: 100%;" src="/images/device/explain-3.jpg" alt="">-->
              <!--                  </div>-->
              <!--                </Poptip>-->
              <!--              </template>-->
            </FormItem>
          </div>
          <div v-if="showPushFiled">
            <Divider></Divider>
          </div>

          <!--          2025年2月17日  新增维保相关字段-->
          <FormItem :label-width="140" :label="$t('l.internal_code')">
            <Input v-model="modal.device.internal_code" :placeholder="$t('l.internal_code')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.CONSUMER')">
            <Input v-model="modal.device.use_unit" :placeholder="$t('l.CONSUMER')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.mt_company_hotline')">
            <Input v-model="modal.device.mt_company_hotline" :placeholder="$t('l.mt_company_hotline')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.insurance_unit')">
            <Input v-model="modal.device.insurance_unit" :placeholder="$t('l.insurance_unit')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.insurance_number')">
            <Input v-model="modal.device.insurance_number" :placeholder="$t('l.insurance_number')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.insurance_expire')">
            <Input v-model="modal.device.insurance_expire" :placeholder="$t('l.insurance_expire')"/>
            <DatePicker type="date" :placeholder="$t('l.insurance_expire')" formate="yyyy-MM-dd"
                        @on-change="modal.device.insurance_expire = $event"
                        :value="modal.device.insurance_expire"/>
          </FormItem><!--          2025年2月17日  新增维保相关字段-->

          <FormItem :label-width="140" :label="$t('l.manufacturing')">
            <Input v-model="modal.device.manufacturing" :placeholder="$t('l.manufacturing')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.mt_company')">
            <Select :placeholder="$t('l.remark83')"
                    v-model="modal.device.mt_cid"
                    filterable
                    remote
                    :remote-method="remoteSearchMT"
                    :loading="modal.searchLoading.mt">
              <Option v-for="(depart) in search.mt_cid.values" :ref="'option'+depart.id"
                      :value="depart.id" :key="depart.id">{{ depart.name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem :label-width="137" :label="$t('l.mt_person')">
            <Select :placeholder="$t('l.remark84')"
                    v-model="modal.mt_worker_mbile"
                    multiple
                    filterable
                    :loading="modal.searchLoading.mt_worker">
              <Option v-for="(member) in search.j_mt_woker.values" :value="member.mobile"
                      :key="member.mobile">{{ member.name }}({{ member.mobile }})
              </Option>
            </Select>
            <Button class="margin-left-10" :title="$t('l.add_maintenance')" @click="addMtWorkers">+</Button>
          </FormItem>
          <FormItem :label-width="137" :label="$t('l.principal')">
            <Select :placeholder="$t('l.remark85')"
                    v-model="modal.fzrs_mobile"
                    multiple
                    filterable
                    :loading="modal.searchLoading.fzrLoading">
              <Option v-for="(member) in search.j_fzrs.values" :value="member.mobile"
                      :key="member.mobile">{{ member.name }}({{ member.mobile }})
              </Option>
            </Select>
            <Button class="margin-left-10" :title="$t('l.add_principal')" @click="addFzrs">+</Button>
          </FormItem>
          <!--&lt;!&ndash; 电梯登记编码 &ndash;&gt;-->
          <!--<FormItem :label-width="140" :label="$t('l.register_number')">-->
          <!--<Input v-model="modal.device.register_number" />-->
          <!--</FormItem>-->

          <FormItem :label-width="140" :label="$t('l.lift_mode')">
            <Input v-model="modal.device.model" :placeholder="$t('l.lift_mode')"/>
          </FormItem>
          <!--电梯类型-->
          <FormItem :label-width="140" :label="$t('l.lift_type')">
            <Select :placeholder="$t('l.remark78')" v-model="modal.device.device_param.type">
              <Option v-for="item in getDeviceTypeList"
                      :value="item.id"
                      :key="item.id">{{ item.lable }}
              </Option>
            </Select>
          </FormItem>

          <FormItem :label-width="140" :label="$t('l.import_agent_name')">
            <Input v-model="modal.device.import_agent_name" :placeholder="$t('l.import_agent_name')"/>
          </FormItem>

          <FormItem :label-width="140" :label="$t('l.production_date')">
            <DatePicker type="date" :placeholder="$t('l.production_date')" formate="yyyy-MM-dd"
                        @on-change="modal.device.production_date = $event"
                        :value="modal.device.production_date"/>
          </FormItem>

          <FormItem :label-width="140" :label="$t('l.installation_name')">
            <Input v-model="modal.device.installation_name" :placeholder="$t('l.installation_name')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.installation_check_date')">
            <DatePicker type="date" :placeholder="$t('l.installation_check_date')" formate="yyyy-MM-dd"
                        @on-change="modal.device.installation_check_date = $event"
                        :value="modal.device.installation_check_date"/>
          </FormItem>

          <FormItem :label-width="140" :label="$t('l.renovation_name')">
            <Input v-model="modal.device.renovation_name" :placeholder="$t('l.renovation_name')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.renovation_check_date')">
            <DatePicker type="date" :placeholder="$t('l.renovation_check_date')" formate="yyyy-MM-dd"
                        @on-change="modal.device.renovation_check_date = $event"
                        :value="modal.device.renovation_check_date"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.major_repairs_name')">
            <Input v-model="modal.device.major_repairs_name" :placeholder="$t('l.major_repairs_name')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.major_repairs_check_date')">
            <DatePicker type="date" :placeholder="$t('l.major_repairs_check_date')" formate="yyyy-MM-dd"
                        @on-change="modal.device.major_repairs_check_date = $event"
                        :value="modal.device.major_repairs_check_date"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.up_rated_speed')">
            <InputNumber :max="20.00" :min="0.00" :step="0.05" v-model="modal.device.up_rated_speed"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.down_rated_speed')">
            <InputNumber :max="20.00" :min="0.00" :step="0.05" v-model="modal.device.down_rated_speed"/>
          </FormItem>


          <FormItem :label-width="140" :label="$t('l.rated_speed')">
            <Input v-model="modal.device.device_param.rated_speed" :placeholder="$t('l.rated_speed')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.rated_load')">
            <Input v-model="modal.device.device_param.rated_load" :placeholder="$t('l.rated_load')"/>
          </FormItem>
          <FormItem v-if="modal.device.type == 0" :label-width="140" :label="$t('l.ad_company')">
            <Select :placeholder="$t('l.remark86')"
                    v-model="modal.device.ad_cid"
                    filterable
                    remote
                    :remote-method="remoteSearchAD"
                    :loading="modal.searchLoading.ad">
              <Option v-for="(depart) in search.ad_cid.values" :value="depart.id" :key="depart.id">
                {{ depart.name }}
              </Option>
            </Select>
          </FormItem>

          <!-- 管理员分配谁能给电梯设置过期时间 -->
          <template v-if="$store.state.user.user.show_lift_endtime||$store.state.user.isROOT">
            <FormItem v-if="modal.device.type == 0" :label-width="140"
                      :label="$t('l.lift_monitor_end_time')">
              <DatePicker type="date" v-model="modal.device.end_time"
                          :placeholder="$t('l.remark200')"></DatePicker>
            </FormItem>
          </template>
          <FormItem v-if="modal.device.type == 0" :label-width="137"
                    :label="$t('l.alarm_mobile')">
            <div style="display: flex;align-content: center;width: 100%">
              <Select :placeholder="$t('l.remark87')+$t('l.remark193')" style="width: 80%"
                      v-model="modal.alarm_charger_mobile"
                      @on-change="addElevatorSelectAlarmUser"
                      multiple
                      filterable
                      clearable
                      @on-clear="modal.alarm_charger_mobile = []; modal.device.j_alarm_charger = null;"
                      :loading="modal.searchLoading.alarm_charger">
                <Option v-for="(member) in search.j_alarm_charger.values"
                        :label="member.name + '('+member.mobile+')'+( member.unsubscribe ? '已退订' : '')"
                        :value="member.mobile"
                        :key="member.mobile">
                    <span :class="{'unsubscribe':member.unsubscribe}">
                      {{ member.name }}({{ member.mobile }}) <span
                        style="color: #cfcfcf;font-size: 9px">{{ member.unsubscribe ? '已退订' : '' }}</span>
                    </span>
                </Option>
              </Select>
              <Button class="margin-left-10" style="height: 26px" :title="$t('l.add_alarm_mobile')"
                      @click="addAlarmCharger">+
              </Button>
              <span class="margin-left-5 alarm-desc" @click="alarmDesc">{{ $t("l.alarm_description") }}</span>
            </div>
          </FormItem>
          <FormItem v-if="$store.state.user.isROOT" :label-width="140" :label="$t('l.sms_enable')">
            <RadioGroup v-model="modal.device.sms_enable">
              <Radio :label="0" key="sms_enable_0"><span>{{ $t('l.sms_enable_0') }}</span></Radio>
              <Radio :label="1" key="sms_enable_1"><span>{{ $t('l.sms_enable_1') }}</span></Radio>
              <Radio :label="2" key="sms_enable_2"><span>{{ $t('l.sms_enable_2') }}</span></Radio>
            </RadioGroup>
            <Poptip word-wrap :width="300" :content="$t('l.explain21')" transfer>
              <img class="cursor-pointor margin-left-10"
                   src="/images/question-mark.svg" alt="">
            </Poptip>
          </FormItem>
          <FormItem v-if="$store.state.user.isROOT" :label-width="140" prop="sms_limit" :label="$t('l.sms_limit')">
            <Input style="width: 200px" v-model="modal.device.sms_limit" :placeholder="$t('l.sms_limit')" type="number"
                   @on-keydown="checkInput($event)"/>
            <Poptip word-wrap :width="300" :content="$t('l.explain22')" transfer>
              <img class="cursor-pointor margin-left-10"
                   src="/images/question-mark.svg" alt="">
            </Poptip>
          </FormItem>
          <FormItem v-if="modal.device.type == 0" :label-width="140" :label="$t('l.add_capacity')">
            <template>
              <Checkbox style="width: 100px;" :value="checkAll" :indeterminate="indeterminate"
                        @click.prevent.native="handleCheckAll"><span
                  class="text-font-size">{{ $t('l.select_all') }}</span>
              </Checkbox>
            </template>
            <template>
              <CheckboxGroup v-model="modal.device.j_extra_capacity" @on-change="checkAllGroupChange">
                <Checkbox v-for="(item,i) in modal.extra_capacity_list" :key="i" border
                          :label="item.index">
                  <span class="text-font-size">{{ $t(item.value) }}</span>
                </Checkbox>
              </CheckboxGroup>
            </template>
          </FormItem>
          <!-- 当前设备绑定的所有用户 -->
          <FormItem style="display: flex;align-items: center" :label="$t('l.band_user')">
            <template v-if="modal.bandUser.length">
              <div style="max-height: 100px;overflow-y: auto">
                <Tag @on-close="unBandUser(elem,index)" closable type="border" color="default"
                     v-for="(elem,index) of modal.bandUser" :key="elem.user_id">{{ elem.realname }}
                </Tag>
              </div>
            </template>
            <template v-else><span>{{ $t("l.remark231") }}</span></template>
          </FormItem>
        </Form>
      </lg-modal>
      <!-- 自定义excel 表格数据导入 -->
      <lg-modal :styles="{top:'60px'}" :width="900" :title="$t('l.set_excel')" :show="excel_file.show"
                @on-cancel="excel_file.show=false"
                :cancel-text="$t('l.cancel')"
                :show-excel-export="true"
                :DetailsForm="excel_file.DetailsForm"
                :confirm-text="$t('l.down_excel')">
        <Row>
          <p class="explain">{{ $t('l.remark203') }}</p>
<!--          2025年10月21日  已处理 不用客户自己手动改-->
<!--          <p style="color: red;">{{ $t("l.remark233") }}</p>-->
        </Row>
        <Row style="max-height: 400px;overflow-y: auto;overflow-x: hidden">
          <Col>
            <Form :model="modal" :label-width="120" label-position="left">
              <!--  小区 -->
              <FormItem :label-width="82" :label="$t('l.community')">
                <Select :placeholder="$t('l.remark71')"
                        v-model="excel_file.DetailsForm[0].community_id"
                        filterable
                        remote
                        :remote-method="remoteSearchCommunity"
                        :loading="modal.searchLoading.community_id"
                        @on-change="onCommunitySelect">
                  <Option v-for="(comm) in search.community_id.values" :value="comm.id"
                          :key="comm.id">{{ comm.name }}
                  </Option>
                </Select>
                <Button class="margin-left-10" :title="$t('l.create_community')"
                        @click="preJumpAddCommunity">+
                </Button>
              </FormItem>
              <!--维保公司-->
              <FormItem :label="$t('l.mt_company')">
                <Select :placeholder="$t('l.remark83')"
                        v-model="excel_file.DetailsForm[0].mt_company_id"
                        filterable
                        remote
                        :remote-method="remoteSearchMT"
                        :loading="modal.searchLoading.mt">
                  <Option v-for="(depart) in search.mt_cid.values" :ref="'option'+depart.id"
                          :value="depart.id" :key="depart.id">{{ depart.name }}
                  </Option>
                </Select>
              </FormItem>
              <!-- 维保人 -->
              <FormItem :label="$t('l.mt_person')">
                <Select :placeholder="$t('l.remark84')"
                        v-model="modal.mt_worker_mbile"
                        multiple
                        @on-change="select_mt_workers"
                        filterable
                        :loading="modal.searchLoading.mt_worker">
                  <Option v-for="(member) in search.j_mt_woker.values" :value="member.mobile"
                          :key="member.mobile">{{ member.name }}({{ member.mobile }})
                  </Option>
                </Select>
                <Button class="margin-left-10" :title="$t('l.mt_person')"
                        @click="preJumpAddMtPerson">+
                </Button>
              </FormItem>
              <!-- 额定速度 -->
              <FormItem :label="$t('l.rated_speed')">
                <InputNumber :step="0.1" v-model="excel_file.DetailsForm[0].speed"  :placeholder="$t('l.rated_speed')"/>
              </FormItem>
              <FormItem :label="$t('l.rated_load')">
                <InputNumber :step="0.1" v-model="excel_file.DetailsForm[0].load" :placeholder="$t('l.rated_load')"/>
              </FormItem>
              <!-- 广告公司 -->
              <FormItem :label="$t('l.ad_company')">
                <Select :placeholder="$t('l.remark86')"
                        v-model="excel_file.DetailsForm[0].ad_cid"
                        filterable
                        remote
                        :remote-method="remoteSearchAD"
                        :loading="modal.searchLoading.ad">
                  <Option v-for="(depart) in search.ad_cid.values" :value="depart.id"
                          :key="depart.id">
                    {{ depart.name }}
                  </Option>
                </Select>
              </FormItem>
              <!-- 故障告警人 -->
              <FormItem :label-width="85" :label="$t('l.alarm_mobile')">
                <div style="display: flex;align-content: center;width: 100%">
                  <Select :placeholder="$t('l.remark87')+$t('l.remark193')" style="width: 75%"
                          v-model="modal.alarm_charger_mobile"
                          @on-change="select_e"
                          :max-tag-count="2"
                          multiple
                          filterable
                          clearable
                          @on-clear="modal.alarm_charger_mobile = []; modal.device.j_alarm_charger = null;"
                          :loading="modal.searchLoading.alarm_charger">
                    <Option v-for="(member) in search.j_alarm_charger.values" :value="member.mobile"
                            :label="member.name + '('+member.mobile+')'+( member.unsubscribe ? '已退订' : '')"
                            :key="member.mobile">
                     <span :class="{'unsubscribe':member.unsubscribe}">
                      {{ member.name }}({{ member.mobile }}) <span
                         style="color: #cfcfcf;font-size: 9px">{{ member.unsubscribe ? '已退订' : '' }}</span>
                    </span>
                    </Option>
                  </Select>
                  <Button class="margin-left-10" :title="$t('l.add_alarm_mobile')" style="height: 26px"
                          @click="addAlarmChargerForImport">+
                  </Button>
                  <span class="margin-left-5 alarm-desc" @click="alarmDesc">{{ $t("l.alarm_description") }}</span>
                </div>
              </FormItem>
              <!-- 楼层 -->
              <FormItem :label="$t('l.total_floor')">
                <InputNumber :step="1" :min="1" :max="64" v-model="excel_file.DetailsForm[0].j_floors" :placeholder="$t('l.lift_mode')"/>
              </FormItem>
              <!-- 电梯型号 -->
              <FormItem :label="$t('l.lift_mode')">
                <Input v-model="excel_file.DetailsForm[0].model" :placeholder="$t('l.lift_mode')"/>
              </FormItem>
              <!-- 贯通门 -->
              <FormItem :label="$t('l.through_door')">
                <i-switch :true-value="1" :false-value="0"
                          v-model="excel_file.DetailsForm[0].is_through_door"></i-switch>
              </FormItem>

              <!-- Excel 批量录入 电梯厂 -->
              <FormItem v-if="$store.state.user.isROOT"  :label="$t('l.manufacturer')">
                <Select @on-select="selectFactoryId"
                        :placeholder="$t('l.remark72')"
                        v-model="excel_file.DetailsForm[0].factory_cid"
                        filterable
                        remote
                        :loading="modal.searchLoading.factory">
                  <Option v-for="(factory) in search.factory_cid.values" :value="factory.id"
                          :key="factory.id">{{ factory.name }}
                  </Option>
                </Select>
              </FormItem>
              <!-- 地址 -->
              <FormItem :label="$t('l.address')">
                <Input type="textarea" v-model="excel_file.DetailsForm[0].address" :placeholder="$t('l.address')"/>
              </FormItem>
              <!-- 备注 -->
              <FormItem :label="$t('l.m_remarker')">
                <Input type="textarea" v-model="excel_file.DetailsForm[0].remark" :placeholder="$t('l.m_remarker')"/>
              </FormItem>
            </Form>
          </Col>
          <Col style="display: none ">
            <Table :columns="getColumns" :data="getData" size="small"
                   ref="table"></Table>
          </Col>
        </Row>
      </lg-modal>
      <!-- 批量修改电梯信息 -->
      <lg-modal :styles="{top: '40px'}"
                @on-visible-change="(e)=>{batchModal.show = e}"
                :width="1300" :title="$t('l.batch_edit_info')"
                :show="batchModal.show" :show-cancel="false" :confirm-text="$t('l.close')"
                @on-submit="batchModal.show=false">
        <batch-update-device
            @remoteSearchFactory="remoteSearchFactory"
            @remoteSearchFactoryBranch="remoteSearchFactoryBranch"
            @remoteSearchMT="remoteSearchMT"
            @remoteSearchAD="remoteSearchAD"
            @remoteSearchMTWorker="remoteSearchMTWorker"
            @addAlarm="addAlarm"
            @addFzr="addFzr"
            @addMtWorker="addMtWorker"
            :mtWorkersMap="mtWorkersMap"
            :chargerMap="chargerMap"
            :fzrMap="fzrMap"
            @save="batchModal.show=false"
            :batchModalShow="batchModal.show"
            :extra_capacity_list="modal.extra_capacity_list"
            :search="search"
            :deviceTypeList="getDeviceTypeList"></batch-update-device>
      </lg-modal>
      <!-- 自定义 标定位置 -->
      <lg-modal  :cancel-text="$t('l.close')" :title="$t('l.select_position')"
                  :z-index="999999"
                :fullscreen="true" :show="locationModal.show" :show-confirm="false"
                @on-cancel="locationModal.show=false">
        <Row style="height: 5%;">
          <div style="display: flex">
            <div>{{ $t('l.current_longitude') }}：<span
                style="font-weight: bold">{{ modal.device.longitude }}</span></div>
            <div style="margin-left: 15px">{{ $t('l.current_latitude') }}：<span
                style="font-weight: bold">{{ modal.device.latitude }}</span>
            </div>
            <div style="margin-left: 15px">{{ $t('l.address') }}：<span
                style="font-weight: bold">{{ modal.device.address }}</span>
            </div>
          </div>
        </Row>
        <Row style="height: 95%;overflow-y: auto">
            <add-tian-map :show="locationModal.show" :center="locationModal.center" @onClickAdd="onMapClickAddMarker" ></add-tian-map>
        </Row>
      </lg-modal>
      <!-- 部件预警值设定 -->
      <lg-modal :width="800" @on-visible-change="(e)=>{warnModal.show = e}" :show="warnModal.show"
                :show-cancel="false" :confirm-text="warnModal.list.length?$t('l.save'):$t('l.close')"
                @on-submit="onSaveWarnParts"
                :title="$t('l.parts_warn_config')">
        <Row>
          <ul class="full-x parts-label-ul">
            <template v-if="warnModal.list.length">
              <li class="parts-label parts-label-title">
                <span style="width: 10%;" class="parts-label-id">ID</span>
                <span style="width: 20%;">{{ $t('l.parts_name') }}</span>
                <span style="width: 20%;">{{ $t('l.life_limit') }} (/h)</span>
                <span class="margin-left-5" style="width: 20%;">{{ $t('l.use_time') }} (/h)</span>
              </li>
              <li class="full-x parts-label" v-for="elem in warnModal.list">
                <span style="width: 10%;" class="parts-label-id">{{ elem.id }}.</span>
                <span style="width: 20%;">{{ elem.name }}</span>
                <Input class="margin-left-5" style="width: 20%;" v-model="elem.limit_life"/>
                <Input disabled style="width: 20%;" :value="elem.use_time?elem.use_time:0"/>
              </li>
            </template>
            <template v-else>
              <div class="to-setting-box">{{ $t('l.remark211') }}<span class="to-setting"
                                                                       @click="()=>{$router.push('/system/settings'),warnModal.show = false}">“{{
                  $t('l.system_setting')
                }}->{{ $t('l.parts_warn_config') }}”</span>{{ $t('l.remark212') }}。
              </div>
            </template>
          </ul>
        </Row>
      </lg-modal>

      <!--      2025年7月17日   王欢  新增推送平台设置-->
      <lg-modal :width="1000"
                @on-visible-change="(e)=>{pusherModal.show = e}"
                :show="pusherModal.show"
                @on-cancel="pusherModal.show=false"
                @on-submit="onSavePusherConfig"
                :title="$t('l.pusher_config')">
        <div class="push-box">
          <Spin fix v-if="pusherModal.spin"></Spin>
          <p style="color: red;font-size: 12px">
            {{ $t("l.remark247") }}
          </p>
          <fieldset v-for="(p,index) in pusherModal.configList" style="border: 2px solid #000">
            <legend>{{ p.name }}</legend>
            <div>
              <Row>
                <template v-if="p.pusher_describe">
                  <Col>
                    <p style="color: red;font-size: 12px">配置说明：{{p.pusher_describe}}</p>
                  </Col>
                </template>

                <Col style="margin: 5px 0" v-for="conf in p.config">
                  <template v-if="conf.is_elevator_field === 0">
                    <span class="s-name" style="display: inline-block;width: 130px">{{ conf.explain }}：</span>
                    <Input v-model="conf.value" style="width: 350px"/>
                  </template>
                </Col>
                <template v-if="p.docs">
                  <span class="s-name" style="display: inline-block;width: 130px">{{ $t("l.doc_explain") }}：</span>
                  <Col v-for="docItem in p.docsArr">
                    <a style="color: #39f" :href="docItem.url" target="_blank">{{ docItem.fileName }}</a>
                  </Col>
                </template>
              </Row>
              <!--              此处渲染子账号信息-->
              <fieldset v-if="p.children &&p.children.length">
                <legend>{{ $t("l.child_account") }}</legend>
                <div class="child-account-box" v-if="p.children &&p.children.length" v-for="(ic,icIndex) in p.children">
                  <div>
                    <div style="display: flex;justify-content: end">
                      <Button @click="removeChildPusherConfig(icIndex,ic,p)" size="small">×</Button>
                    </div>
                    <Col>
                      <span class="s-name" style="display: inline-block;width: 130px">{{ $t("l.pusher_name") }}：</span>
                      <Input style="width: 350px" v-model="ic.name"/>
                    </Col>
                    <Col style="margin: 5px 0" v-for="icItem in ic.config">
                      <template v-if="icItem.is_elevator_field === 0">
                        <span class="s-name" style="display: inline-block;width: 130px">{{ icItem.explain }}：</span>
                        <Input v-model="icItem.value" style="width: 350px"/>
                      </template>
                    </Col>
                  </div>
                </div>
              </fieldset>
              <div style="display: flex;justify-content: end" class="margin-top-10">
<!--                2025年7月30日  按照柳要求 只有这些平台用子账号-->
                <template v-if="p.label === 'pusher_chongqing'">
                  <Button class="margin-left-10" size="small" :title="$t('l.add_alarm_mobile')"
                          @click="addPushAccount(p)">{{ $t("l.add_account") }}
                  </Button>
                </template>
<!--                2025年7月30日 按照柳要求 武汉需要电梯云平台自己生成账号密码  反馈给推送平台-->
                <template v-if="p.label === 'pusher_wuhan'">
                  <Button class="margin-left-10" size="small" :title="$t('l.wuhan_pusher_config')"
                          @click="wuHanPusherConfig(p)">{{ $t("l.wuhan_pusher_config") }}
                  </Button>
                </template>
              </div>
            </div>
          </fieldset>
        </div>
      </lg-modal>

      <lg-modal :width="1300"
                @on-visible-change="(e)=>{batchPusherModal.show = e}"
                :show="batchPusherModal.show"
                :loading="batchPusherModal.btnLoading"
                @on-cancel="batchPusherModal.show=false"
                @on-submit="onBatchSavePusherConfig"
                :title="$t('l.batch_set_config')">
        <div style="display: flex;justify-content: space-between">
          <div style="display: flex;align-items: center">
            <span>{{ $t("l.push_scheme") }}：</span>
            <Select @on-change="chooseSelectOfBatchPusher" v-model="batchPusherModal.push_scheme_code"
                    style="width:200px">
              <Option value="" key="" selected>{{ $t("l.none") }}({{ $t("l.cancel_access") }})</Option>
              <Option v-for="item in pusherModal.schemeConfigList" :value="item.code" :key="item.code">
                {{ item.name }}
              </Option>
            </Select>
            <span class="push-file-box">
                  <a class="margin-left-10" v-for="fileItem in pusherModal.currentPusherFile" :href="fileItem.url"
                     style="color: #39f">{{ fileItem.name }}</a>
                </span>
          </div>
          <div>
            <Input v-model="batchPusherModal.table.page.search"
                   style="width: 400px"
                   :placeholder="$t('l.remark248')"
                   class="margin-right-10"/>
            <Button type="primary" @click="loadDeviceForPusher(1)">{{ $t("l.search") }}</Button>
          </div>
        </div>
        <div class="margin-top-10" style="max-height: 600px;overflow-y: auto">

          <!--            <div>{{batchPusherModal.selectedDevices}}</div>-->
          <Table border
                 :columns="getDeviceForPushColumns"
                 :data="batchPusherModal.table.data"
                 @on-select="onSelectDeviceForPusher"
                 @on-select-cancel="onCancelSelectDeviceForPusher"
                 @on-select-all="onSelectAllDeviceForPusher"
                 @on-select-all-cancel="onCancelSelectAllDeviceForPusher"
                 size="small">
          </Table>
        </div>
        <div class="margin-top-10" style="display: flex;justify-content: center">
          <Page size="small"
                :current="batchPusherModal.table.page.current"
                :page-size="batchPusherModal.table.page.size"
                :total="batchPusherModal.table.page.total"
                :page-size-opts="batchPusherModal.table.page.sizeOptions"
                show-elevator show-sizer show-total
                @on-page-size-change="($event)=>{batchPusherModal.table.page.size = $event,loadDeviceForPusher(1)}"
                @on-change="loadDeviceForPusher($event)">
          </Page>
        </div>
      </lg-modal>

    </template>
  </base-page>
</template>

<script>
import monitorUtil from './modules/list-monitor';
import axios from 'axios';
import util from '@/libs/util';
import liftGroups from './component/lift-groups';
import RadioGroup from 'iview/src/components/radio/radio-group';
import BasePage from "../my-components/base-page";
import LgModal from "../my-components/lg-modal";
import SearchBar from "./component/search-bar";
import SearchModal from "./component/search-modal";
import FloorEditor from "./component/floor-editor";
import ResView from "../my-components/res-view";
import extraConfig from "../../constant-data/extra-config";
import batchUpdateDevice from "./component/batch-update-device";
import AddTianMap from "./component/add-tian-map.vue";
import ws from '@/libs/websocket'
import QRCode from "qrcode";
import Print from "print-js";
import utils from "videojs-contrib-hls/es5/bin-utils";
import TianMap from "@/views/device/component/tian-map.vue";


let roleTypes = {
  ROOT: 1,
  AMDIN: 2,
  PROXY: 3,
  ELEV_FACTORY: 4,
  MT_COMPANY: 5,
  WY_COMPANY: 6,
  GOV: 7,
  AD: 8,
  CONSUMER: 10
}

export default {
  name: 'page-device',
  components: {
    TianMap,
    AddTianMap,
    ResView,
    // BmInfoWindow,
    // BmMapType,
    // BaiduMap,
    // // BmView,
    // BmControl,
    // BmAutoComplete, BmLocalSearch,
    // BmScale,
    // BmMarker,
    // BmNavigation,
    // BmlMarkerClusterer,
    FloorEditor,
    SearchModal,
    SearchBar,
    LgModal,
    BasePage,
    RadioGroup,
    liftGroups,
    batchUpdateDevice
  },
  data() {
    return {
      validateTotalFloor: (rule, value, callback) => {
        if (value <= 0 || value > 64) {
          callback(new Error(this.$t('l.remark89')));
        } else if (!value) {
          callback(new Error(this.$t('l.remark33')));
        } else {
          callback();
        }
      },
      showTableData: false,
      modal: {
        current_describe: '',
        current_radio: 0,
        show: false,
        showFace: false,
        // currentDeviceIsHost: false,
        showFloorEditor: false,
        title: this.$t('l.add_device'),
        loading: false,
        switch: false, // 贯通门选
        // distantUpdate: false,//楼层别名远程同步至android端
        currentIndex: -1,
        totalFloor: 0,
        current_selected_terminal: '',// 当前选择的终端
        searchLoading: {
          community_id: false,
          factory: false,
          factoryBranch: false,
          mt: false,
          ad: false,
          mt_worker: false,
          alarm_charger: false,
          real_devices: false,
          regionLoading: false,
          fzrLoading: false
        },
        alarm_charger_mobile: [],
        alarm_charger_mobile_batch: [],
        fzrs_mobile: [],
        mt_worker_mbile: [],
        filed_list: [], //  地方监管接口必填字段列表
        push_way: [],  // 地方监管接口推送 方式
        locationTree: [],
        choosedLocationIds: [],
        device: {
          internal_code: '',
          use_unit: '',
          mt_company_hotline: '',
          insurance_unit: '',
          insurance_number: '',
          insurance_expire: '',
          code: '',
          model: '',
          stream_m3u8: "",
          // is_remote_controls: false,
          device_param: {
            rated_speed: "",
            rated_load: "",
            type: 0,
            is_through_door: 0,
            manual_door: 0,
          },
          longitude: 0,
          latitude: 0,
          vm_device_id: "",
          type: 0,
          name: '',
          qr_id: 0,
          j_floors: {
            display: [],
            unstop: [],
            negative: 0, // 负楼层
            positive: 0     //正楼层
          },
          j_param: {},
          community_id: 0,
          terminal_id: null,
          terminal_id_curve: null, // 曲线终端
          face_id: null,
          j_location: {},
          factory_cid: 0,
          factory_branch: 0,
          mt_cid: 0,
          j_mt_workers: [],
          j_fzrs: [], // 电梯负责人
          ad_cid: 0,
          j_alarm_charger: null,
          sms_enable: 1,
          sms_limit: 0,
          j_extra_capacity: [],
          regulatory_field: {way: ''},
          city_id: 0,
          address: '',
          end_time: "",
          equipment_code: '', // 设备代码
          // register_number:'',   // 登记证编号
          brand: '', // 品牌
          //   2025年2月5日 王欢 补全威海质监局要求的字段
          // variety: 2,  //  设备品种
          manufacturing: '',  //   制造单位名称
          import_agent_name: '',    //   进口代理商名称
          production_date: '',//   出厂日期  YYYY-MM-DD
          installation_name: '',//   安装单位名称
          installation_check_date: '',  //   安装监督检验日期  YYYY-MM-DD
          renovation_name: '',  //   改造单位名称
          renovation_check_date: '',  //   改造监督检验日期  YYYY-MM-DD
          major_repairs_name: '', //   重大修理单位名称
          major_repairs_check_date: '', //   重大修理监督检验日期  YYYY-MM-DD
          doors: 1,  //   电梯层门数
          up_rated_speed: 0.00,          //   电梯上行额定速度
          down_rated_speed: 0.00,  //   电梯下行额定速度
          push_scheme_code: '',     // 推送方案唯一标识  2025年7月21日
        },
        device_2g: {
          DEVICE_NUM: '',
          IMSI: '',
          FLOOR: '',
          STATION: '',
          USEDATE: null,
          DOOR: '',
          MANUFACTUREDATE: '',
          XCNJRQ: '',
          Delivery: 0,
          CONTRACT: '',
          INSTALLATION: '',
          INSTALLATIONMAN: '',
          INSTALLATIONMANMOBILE: '',
          CONSUMER: 0,
          USEOCCASION: '',
          OWNER: '',
          PROPERTY: 0,
          WYRY: '',
          WYDH: '',
        },
        extra_capacity_list: extraConfig,
        bandUser: [],

      },
      show: false,
      checkAll: false,
      indeterminate: false,
      realDevices: [], // 真实电梯
      search: {
        type: {
          label: this.$t('l.device_type'),
          values: [
            {id: 0, name: this.$t('l.lift'), isAuth: true, show: true},
            {id: 3, name: this.$t('l.virtual_lift'), show: true, isAuth: this.$ifauth('fun_vm_device')},
            {id: 4, name: "2G WCR", show: true, isAuth: true}
          ],
          selected: []
        },
        // 推送平台
        pusher_type: {
          label: this.$t('l.select_push_city'),
          values: [],
          selected: []
        },
        device_state: {
          label: this.$t('l.lift_status'),
          values: [
            {id: 0, name: this.$t('l.online')},
            {id: 1, name: this.$t('l.offline')},
            {id: 2, name: this.$t('l.fault')},
            {id: 3, name: this.$t('l.ExpireCount')},
          ],
          selected: [],
        },
        end_date_range: {
          selected: [],
          values: []
        },
        new_old: {
          label: this.$t('l.terminal_type'),
          values: [
            {id: 0, name: 'WCR'},
            {id: 1, name: this.$t('l.smart_screen')},
          ],
          selected: [],
        },
        community_id: {
          label: this.$t('l.community'),
          values: [],
          selected: [],
          handler: this.onCommunityChoosed.bind(this)
        },
        building_id: {
          label: this.$t('l.build_unit'),
          values: [],
          selected: []
        },
        factory_cid: {
          label: this.$t('l.manufacturer'),
          values: [],
          selected: []
        },
        factory_branch: {
          label: this.$t('l.manufacturer_branch'),
          values: [],
          selected: []
        },
        mt_cid: {
          label: this.$t('l.mt_company'),
          values: [],
          selected: []
        },
        j_mt_woker: {
          label: this.$t('l.mt_person'),
          disabled: true,
          values: [],
          selected: []
        },
        j_fzrs: {
          label: this.$t('l.principal'),
          disabled: true,
          values: [],
          selected: []
        },
        ad_cid: {
          label: this.$t('l.ad_company'),
          values: [],
          selected: []
        },
        j_alarm_charger: {
          label: this.$t('l.alarm_mobile'),
          values: [],
          selected: []
        }
      },
      searchLoading:false,
      table: {
        data: [],
        page: {
          current: 1,  // 当前页码
          size: 24, // 每页个数
          sizeOptions: [12, 18, 24, 48, 60],
          total: 0,
          sortKey: 'online',
          sortMethod: 'desc',
          keyword: ''
        },
        loading: false,
        loadTime: 0,
        columns: [
          {
            key: 'id',
            title: "ID",
            align: 'center'
          },
          {
            key: 'name',
            title: "设备名称",
            align: 'center'
          },
          {
            key: 'code',
            title: '电梯编号',
            align: 'center'
          },
          {
            key: 'model',
            title: '型号',
            align: 'center'
          },
          {
            key: 'community_name',
            title: '小区',
            align: 'center'
          },
          {
            key: 'address',
            title: '位置',
            align: 'center'
          },
          {
            key: 'floor',
            title: '楼层',
            align: 'center',
            render: (h, params) => {
              return h('span', {}, params.row.j_floors ? params.row.j_floors.display.length : 0);
            }
          },
          {
            key: 'terminal_id',
            title: '终端ID',
            align: 'center'
          },
          {
            key: 'brand',
            title: '品牌',
            align: 'center',
            render: (h, params) => {
              return h('span', {}, params.row.brand ? params.row.brand : params.row.factory_name);
            }
          },
          {
            key: 'online',
            title: '状态',
            align: 'center',
            render: (h, params) => {
              return h('span', {}, params.row.online ? '在线' : '离线');
            }
          },

        ]
      },
      showOption: false,
      batch: {
        list: [],
        showBatch: false
      },
      otherModals: {
        searchSelect: false,// 是否展示筛选框
      },
      monitorList: {
        showMonitor: false,
        likes: [],
      },
      uploadAddress: util.baseURL + 'device/upload_deviceInfo',
      loading: {
        upload: false
      },
      ifShowBatch: false,
      deleteLoading: false,
      routeName: '',
      excel_file: {
        show: false,
        table: {
          columns: [],
          data: []
        },
        DetailsForm: [{
          name: 'xxxx电梯',
          yd_unique_code: '',
          code: '',
          model: '',
          iccid:"",
          terminal_id: '',
          equipment_code: '',
          is_through_door: 0,
          j_floors: 0,
          brand: '',
          community_id: '',
          mt_cid: 0,
          j_mt_workers: [],
          speed: 0,
          load: 0,
          ad_cid: 0,
          factory_cid: 0,
          j_alarm_charger: [],
          address: '',
          remark: '',
        }]
      },
      mapDrawer: {
        show: false,
        center: [ // 初始位置给北京
          116.404, 39.915
        ],
        markers: [], // 当前公司所有设备地理位置显示坐标点
        infoWindow: {
          show: false,
          info: {}
        }
      },
      batchModal: {
        show: false
      },
      locationModal: {
        show: false,
        center: [ // 初始位置给北京
          116.414537,
          39.915795
        ],
        zoom: 10,
        keyword: ''
      },
      warnModal: {
        show: false,
        currentWarnConfig: [],
        list: [],
        id: 0, // 当前设备id
      },

      // 2025年7月17日  推送平台设置
      pusherModal: {
        show: false,
        spin: false,
        configList: [],
        currentPusherFile: [],
        schemeConfigList: [],  //   查询当前电梯厂所有推送配置方案
      },
      batchPusherModal: {
        show: false,
        btnLoading: false,
        push_scheme_code: '0',
        table: {
          loading: false,
          data: [],
          page: {
            search: '',
            current: 1,
            size: 20,
            total: 0,
            sizeOptions: [20, 40, 60, 80]
          },
        },
        selectedDevices: [],   // 所有项选择
      },
      exportDataLoading: false
    };
  },
  methods: {
    handler(e) {
      // this.loadLocationMarks();
    },
    select_e(mobiles) {
      if (mobiles.length > 2) {
        this.modal.alarm_charger_mobile = mobiles.slice(0,2);
        this.$Message.error(this.$t('l.remark193'));
        return;
      }
      this.modal.alarm_charger_mobile = mobiles;
      let v = [];
      this.search.j_alarm_charger.values.forEach((elem) => {
        if (mobiles.includes(elem.mobile)) {
          v.push(elem);
        }
      });
      this.excel_file.DetailsForm[0].j_alarm_charger = [];

      if (v && v.length) {
        v.forEach(item => {
          this.excel_file.DetailsForm[0].j_alarm_charger.push({
            mobile: item.mobile,
            name: item.name
          });
        });

        this.excel_file.DetailsForm[0].j_alarm_charger = JSON.stringify(this.excel_file.DetailsForm[0].j_alarm_charger);
      }
    },
    select_mt_workers(mobile) {
      let v = [];
      this.search.j_mt_woker.values.forEach((elem) => {
        if (mobile.indexOf(elem.mobile) > -1) {
          v.push(elem);
        }
      });
      this.excel_file.DetailsForm[0].j_mt_workers = [];
      if (v && v.length) {
        v.forEach(item => {
          this.excel_file.DetailsForm[0].j_mt_workers.push({
            mobile: item.mobile,
            name: item.name
          });
        });
        this.excel_file.DetailsForm[0].j_mt_workers = JSON.stringify(this.getData[0].j_mt_workers);
      }
    },
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      if (this.checkAll) {
        this.modal.device.j_extra_capacity = this.modal.extra_capacity_list.map(item => {
          return item.index;
        });
      } else {
        this.modal.device.j_extra_capacity = [];
      }
    },
    checkAllGroupChange(data) {
      if (data.length === this.modal.extra_capacity_list.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    onCommunityChoosed(isAdd, index) {
      if (isAdd && this.search.community_id.selected.length === 1) {
        let comm = this.search.community_id.values[index];
        comm.j_buildings = util.parseJSON(comm.j_buildings, []);
        this.search.building_id.values = comm.j_buildings;
      } else {
        this.search.building_id.values = [];
      }
      this.search.building_id.selected = [];
    },
    clear() {
      this.batch.list = []
    },
    onCommunitySelect(commId) { // 编辑小区 如果更换小区那么新的绑定地址也得更换
      if (!commId) return;
      let community = this.search.community_id.values.find(comm => {
        return comm.id === commId;
      })
      this.modal.choosedLocationIds = []
      if (community) {
        if (!this.modal.device.address) { // 绑定小区了，但是没有详细device.address字段 为null
          if (community.j_region) {
            this.modal.device.address = community.j_region.province.name +
                community.j_region.city.name + (community.j_region.area ? community.j_region.area.name + (community.address ? community.address : '') : '')
          }
        }
        if (this.excel_file.show) { // 导出 选着小区
          this.getData[0].community_id = community.id;
          this.getData[0].city_id = community.city_id;
        } else {
          if (this.modal.device.type == 3) { // 查询真实电梯
            util.ajax.get("device/getrealdevice", {
              params: {
                cid: this.modal.device.community_id,
                bid: 0,
                uid: 0,
                type: this.modal.device.type
              }
            }).then(res => {
              this.realDevices = []
              if (!res.code && res.data) {
                res.data.forEach(item => {
                  if (item.terminal_id) {
                    this.realDevices.push(item)
                  }
                })
              }
            })
          }
        }
        this.modal.locationTree = util.parseJSON(community.j_buildings, []);
        this.modal.locationTree.forEach(b => {
          b.value = b.id;
          b.label = b.name;
          b.children = b.units;
          b.units.forEach(u => {
            u.value = u.id;
            u.label = u.name;
            u.children = u.doors;
            u.doors.forEach(d => {
              d.value = d.id;
              d.label = d.name;
            })
          })
        })
      }
    },
    onRealDeviceSelect(deviceId) {
      if (!deviceId) return;
      if (!deviceId.includes("vm")) {
        let start = deviceId.indexOf("【") + 1;
        let end = deviceId.indexOf("】");
        deviceId = 'vm_' + deviceId.substring(start, end);
      }
      let realDeviceInfo = this.realDevices.find(de => {
        return 'vm_' + de.terminal_id == deviceId;
      })
      if (realDeviceInfo) {
        this.modal.device.vm_device_id = deviceId;
        this.modal.device.device_param = JSON.parse(realDeviceInfo.device_param);
        this.modal.device.j_location = JSON.parse(realDeviceInfo.j_location)
        this.modal.device.j_floors = JSON.parse(realDeviceInfo.j_floors);
        this.modal.device.online = realDeviceInfo.online;
        this.modal.device.community_id = realDeviceInfo.community_id;
        this.modal.current_selected_terminal = realDeviceInfo.name + "【" + realDeviceInfo.terminal_id + "】"
      }
    },
    // 选择楼、单元
    onLocationSelect(value, selected) {
      let location = this.modal.device.j_location = {};
      if (selected[0]) location.building = {
        id: selected[0].id,
        name: selected[0].name
      };
      if (selected[1]) location.unit = {
        id: selected[1].id,
        name: selected[1].name
      };
      if (this.excel_file.show) {
        this.getData[0].j_location = {}
        this.getData[0].j_location = location;
      }
      // 确定 电梯 qr_id 乘梯使用证书
      // this.modal.device.qr_id = this.modal.device.community_id+"-"+selected[0].id+(selected[1].id?"-"+selected[1].id:"")
      // if (selected[2]) location.door = {
      //     id: selected[2].id,
      //     name: selected[2].name
      // };
    },
    selectFactoryId(val) {
      if (this.excel_file.show) {
        this.getData[0].factory_cid = this.modal.device.factory_cid
      }
    },
    onSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.modal.device.device_param.is_through_door) { //
            if (this.modal.totalFloor > 32) {
              this.$Message.error(this.$t('l.hint43'))
              return;
            }
          }
          let device = this.modal.device;
          if (device.end_time) device.end_time = typeof device.end_time === 'string' ? device.end_time : device.end_time.pattern("yyyy-MM-dd");
          else device.end_time = null;
          delete device.aesIdCode;
          delete device.community_name;
          delete device.transtionShow;
          delete device.params_settings;
          delete device.terminal_type;
          delete device.factory_name;
          delete device.isExpire; // 用于判断是否过期
          delete device.rolling_code_index;
          delete device.broken;
          delete device.caddress;
          delete device.current_status;

          if (this.modal.alarm_charger_mobile.length) { // 告警人最多填写五位
            if (this.modal.alarm_charger_mobile.length > 2) {
              this.$Message.error(this.$t('l.remark193'))
              return;
            }
            device.j_alarm_charger = [];
            this.modal.alarm_charger_mobile.forEach(mobile => {
              let charger = this.chargerMap[mobile];
              if (charger) {
                device.j_alarm_charger.push({
                  mobile: charger.mobile,
                  name: charger.name
                });
              } else {
                device.j_alarm_charger = []
              }
            })
          } else {
            device.j_alarm_charger = null;
          }
          device.sms_enable = this.modal.device.sms_enable;
          device.sms_limit = this.modal.device.sms_limit;
          // 短信使能
          if (this.modal.fzrs_mobile.length) { // 负责人
            device.j_fzrs = [];
            this.modal.fzrs_mobile.forEach(mobile => {
              let fzr = this.fzrMap[mobile];
              if (fzr) {
                device.j_fzrs.push({
                  mobile: fzr.mobile,
                  name: fzr.name
                });
              }
            })
          } else {
            device.j_fzrs = null;
          }
          if (this.modal.mt_worker_mbile.length) { // 维保人
            device.j_mt_workers = [];
            this.modal.mt_worker_mbile.forEach(mobile => {
              let mt = this.mtWorkersMap[mobile];
              if (mt) {
                device.j_mt_workers.push({
                  mobile: mt.mobile,
                  name: mt.name
                });
              }
            })
          } else {
            device.j_mt_workers = null;
          }
          if (!device.terminal_id) device.terminal_id = null
          if (!device.face_id) device.face_id = null
          device.j_param = device.j_param ? device.j_param : {}
          var patt = /W_|L_|T_|E[0-9]/;
          if (device.terminal_id && !patt.test(device.terminal_id)) {
            this.$Message.error(this.$t("l.remark202"));
            return;
          }
          // 验证绑定终端id是否合法，
          if (device.terminal_id && ((device.terminal_id.startsWith("L") || device.terminal_id.startsWith("T") || device.terminal_id.startsWith("W")) && device.terminal_id.length != 16)) {
            this.$Message.error(this.$t("l.remark202"));
            return;
          }
          //  2G版本wcr设备
          if (device.type == 4) {
            let device_2G = this.modal.device_2g;
            if (!device_2G.FLOOR) {
              this.$Message.error(this.$t('l.remark24'));
              return;
            }
            if (!device_2G.DEVICE_NUM) {
              this.$Message.error(this.$t('l.remark24'));
              return;
            }
            if (!device.terminal_id || !device_2G.IMSI) {
              this.$Message.error("请填写IMSI");
              return;
            }
            if (device.terminal_id.length != 14) {
              this.$Message.error("BS号不合法");
              return;
            }
            if (device_2G.USEDATE) {
              device_2G.USEDATE = new Date(device_2G.USEDATE).pattern("yyyy-MM-dd HH:mm:ss")
            }
            if (device_2G.MANUFACTUREDATE) {
              device_2G.MANUFACTUREDATE = new Date(device_2G.MANUFACTUREDATE).pattern("yyyy-MM-dd HH:mm:ss")
            }
            if (device_2G.XCNJRQ) {
              device_2G.XCNJRQ = new Date(device_2G.XCNJRQ).pattern("yyyy-MM-dd HH:mm:ss")
            }
            Object.assign(device, device_2G);
          }

          // 判断如果选择了推送平台，必须填写厂家代码和设备代码
          if (device.regulatory_field && device.regulatory_field.way && (!device.code || !device.equipment_code) && device.regulatory_field.way != "pusher_shanghai") {
            this.$Message.error("如果配置推送平台则必须填写厂家代码和设备代码");
            return;
          }

          if (!device.regulatory_field.way) {
            device.regulatory_field = {};
          }

          // 是否开启远程控制
          // if (device.is_remote_controls) {
          //   device.is_remote_controls = "1";
          // } else {
          //   device.is_remote_controls = "0";
          // }


          // 判断是否为合法的m3u8  格式
          if (device.stream_m3u8) {
            if (!/^[^\s()<>]+\.(m3u8)$/.test(device.stream_m3u8.replace(/\s/g, ""))) {
              this.$Message.error(this.$t('l.remark242'));
              return;
            }

          }


          if (device.id) { // update
            this.modal.loading = true;
            util.ajax.put('/device/update', {
              device: device,
            }).then(res => {
              this.modal.loading = false;
              if (!res.code) {
                this.modal.show = false;
                Object.keys(device).forEach(field => {
                  this.table.data[this.modal.currentIndex][field] = device[field];
                })
                this.modal.currentIndex = -1;
                this.loadData(this.table.page.current, this.search);
                this.$Message.success(this.$t('l.edit_success'))
              }
            })
          } else { // 添加设备
            this.modal.loading = true;
            util.ajax.post('/device/add', device).then(res => {
              this.modal.loading = false;
              if (!res.code) {
                this.modal.show = false;
                this.loadData(this.table.page.current, this.search);
                this.$Message.success(this.$t('l.add_success'))
              }
            }).catch(e => {
              this.modal.loading = false;
            })
          }
        } else {
          this.$Message.error(this.$t('l.remark24'));
        }
      })
    },
    preAdd(name) {
      this.search.type.values[1].show = true;
      this.modal.show = true;
      this.pusherModal.currentPusherFile = [];
      let d = this.modal.device = {
        internal_code: '',
        use_unit: '',
        mt_company_hotline: '',
        insurance_unit: '',
        insurance_number: '',
        insurance_expire: '',
        type: 0,
        name: '',
        end_time: "",
        j_floors: {
          display: [],
          unstop: [],
          negative: 0,
          positive: 0
        },
        longitude: 0,
        latitude: 0,
        j_param: {},
        community_id: 0,
        vm_device_id: '',
        qr_id: 0,
        terminal_id: '',
        terminal_id_curve: '',
        j_location: {},
        factory_cid: 0,
        factory_branch: 0,
        mt_cid: 0,
        j_mt_workers: [],
        j_fzrs: [],
        ad_cid: 0,
        j_alarm_charger: null,
        sms_enable: 1,
        sms_limit: 0,
        device_param: {
          rated_speed: "",
          rated_load: "",
          type: 0,
          is_through_door: 0,
          manual_door: 0
        },
        regulatory_field: {},
        city_id: 0,
        address: '',
        brand: '',
        equipment_code: '', // 设备代码
        // register_number:'',   // 登记证编号
        // variety: 2,  //  设备品种
        manufacturing: '',  //   制造单位名称
        import_agent_name: '',    //   进口代理商名称
        production_date: '',//   出厂日期  YYYY-MM-DD
        installation_name: '',//   安装单位名称
        installation_check_date: '',  //   安装监督检验日期  YYYY-MM-DD
        renovation_name: '',  //   改造单位名称
        renovation_check_date: '',  //   改造监督检验日期  YYYY-MM-DD
        major_repairs_name: '', //   重大修理单位名称
        major_repairs_check_date: '', //   重大修理监督检验日期  YYYY-MM-DD
        doors: 1,  //   电梯层门数
        up_rated_speed: 0.00,          //   电梯上行额定速度
        down_rated_speed: 0.00,  //   电梯下行额定速度
        push_scheme_code: ''
      }
      this.modal.alarm_charger_mobile = [];
      this.modal.fzrs_mobile = [];
      this.modal.mt_worker_mbile = []
      this.modal.totalFloor = 0;
      // 当前登陆公司
      let myCompany = this.$store.state.user.user.company;
      switch (myCompany.role_id) {
          // 如果是电梯厂
        case roleTypes.ELEV_FACTORY:
          if (myCompany.type == 0) { // 公司
            d.factory_cid = myCompany.id;
          } else {
            d.factory_cid = myCompany.pid;
            d.factory_branch = myCompany.id;
          }
          break;
        case roleTypes.MT_COMPANY:
          d.mt_cid = myCompany.id;
          this.remoteSearchMTWorker(myCompany.id);
          break;
        case roleTypes.AD:
          d.ad_cid = myCompany.id;
          break;
      }
      this.modal.filed_list = []
      this.modal.choosedLocationIds = []
      this.loadPusherSchemeConfig();
    },


    switch_change_through(val) {
      if (val) {
        if (this.modal.totalFloor > 32) {
          this.$Modal.warning({
            content: this.$t('l.remark172')
          })
          this.$refs.switch_change_through.toggle({
            preventDefault: () => {
            }
          });
          return;
        }
        this.modal.device.device_param.is_through_door = 1;
        let partA = [];
        let partB = [];
        for (let i = 1; i <= this.modal.device.j_floors.negative; i++) {
          partA.unshift((-i).toString() + 'A');
          partB.unshift((-i).toString() + 'B');
        }
        for (let i = 1; i <= this.modal.device.j_floors.positive; i++) {
          partA.push(i.toString() + 'A');
          partB.push(i.toString() + 'B');
        }

        this.modal.device.j_floors.display = partA.concat(partB);
      } else {
        this.modal.device.device_param.is_through_door = 0;
        this.modal.device.j_floors.display = [];
        for (let i = 1; i <= this.modal.device.j_floors.negative; i++) {
          this.modal.device.j_floors.display.unshift((-i).toString());
        }
        for (let i = 1; i <= this.modal.device.j_floors.positive; i++) {
          this.modal.device.j_floors.display.push(i.toString());
        }
      }
    },
    onTotalFloorChange(value, upORdown) {
      this.modal.totalFloor = this.modal.device.j_floors.positive + this.modal.device.j_floors.negative;
      let originSize = this.modal.device.j_floors.display.length; // 修改之前的总楼层
      if (this.modal.device.device_param.is_through_door) {
        // 根据修改之前的楼层显示，分组
        let oriFloor = originSize / 2; // 修改之前 贯通门总楼层
        let partA = this.modal.device.j_floors.display.slice(0, oriFloor);
        let partB = this.modal.device.j_floors.display.slice(-oriFloor);

        let partAdown = partA.slice(0, upORdown > 0 ? this.modal.device.j_floors.negative : (oriFloor - this.modal.device.j_floors.positive));
        let partAup = partA.slice(upORdown > 0 ? this.modal.device.j_floors.negative : (oriFloor - this.modal.device.j_floors.positive));
        let partBdown = partB.slice(0, upORdown > 0 ? this.modal.device.j_floors.negative : (oriFloor - this.modal.device.j_floors.positive));
        let partBup = partB.slice(upORdown > 0 ? this.modal.device.j_floors.negative : (oriFloor - this.modal.device.j_floors.positive));

        if (upORdown > 0) {
          if (partAup.length < value) {
            for (let i = partAup.length + 1; i <= value; i++) {
              partAup.push(i.toString() + 'A');
              partBup.push(i.toString() + 'B');
            }
          } else if (partAup.length > value) {
            partAup.splice(value, partAup.length - value);
            partBup.splice(value, partBup.length - value);
          }
        } else if (upORdown < 0) {
          if (partAdown.length < value) {
            for (let i = partAdown.length + 1; i <= value; i++) {
              partAdown.unshift((-i).toString() + 'A');
              partBdown.unshift((-i).toString() + 'B');
            }
          } else if (partAdown.length > value) {
            partAdown.splice(0, partAdown.length - value);
            partBdown.splice(0, partBdown.length - value);
          }
        }

        this.modal.device.j_floors.display = partAdown.concat(partAup).concat(partBdown).concat(partBup)
      } else {
        let partDOWN = this.modal.device.j_floors.display.slice(0, upORdown > 0 ? this.modal.device.j_floors.negative : (originSize - this.modal.device.j_floors.positive));
        let partUP = this.modal.device.j_floors.display.slice(upORdown > 0 ? this.modal.device.j_floors.negative : (-(originSize - this.modal.device.j_floors.positive)));
        if (upORdown > 0) {
          if (partUP.length < value) {
            for (let i = partUP.length + 1; i <= value; i++) {
              this.modal.device.j_floors.display.push(i.toString());
            }
          } else if (partUP.length > value) {
            this.modal.device.j_floors.display.splice(value + this.modal.device.j_floors.negative, partUP.length - value);
          }
        } else { // 修改负楼层
          if (partDOWN.length < value) { // 新的负楼层多
            for (let i = partDOWN.length + 1; i <= value; i++) {
              this.modal.device.j_floors.display.unshift((-i).toString());
            }
          } else if (partDOWN.length > value) { // 新的负楼层少
            this.modal.device.j_floors.display.splice(0, partDOWN.length - value);
          }
        }
      }
    },
     preEdit({device:currentDevice, index}) {
      this.modal.loading = true;
       this.modal.title = this.$t('l.device_info');
       this.pusherModal.currentPusherFile = [];
       console.log("currentDevice:",currentDevice);
       util.ajax.get('/device/getbyid', {
         params: {
           id: currentDevice.id
         }
       }).then(res=>{
         this.modal.loading = false;
         if(!res.code){
           console.log(res.data)
           let device = res.data;
           this.onCommunitySelect(device.community_id);
           this.$refs.setQuery.setQuery(device.community_name)
           this.modal.currentIndex = index;

           this.search.type.values[1].show = false;
           if (!device.regulatory_field) device.regulatory_field = {way: ''};
           else device.regulatory_field = typeof device.regulatory_field == 'string' ? JSON.parse(device.regulatory_field) : device.regulatory_field;
           device.device_param = typeof device.device_param == 'string' ? JSON.parse(device.device_param) : device.device_param;
           if (!device.device_param.hasOwnProperty("manual_door")) {
             device.device_param.manual_door = 0;
           }
           device.j_floors = typeof device.j_floors == 'string' ? util.parseJSON(device.j_floors,{}) : device.j_floors;
           device.j_alarm_charger = typeof device.j_alarm_charger == 'string' ? util.parseJSON(device.j_alarm_charger,{}) : device.j_alarm_charger;
           device.j_fzrs = typeof device.j_fzrs == 'string' ? util.parseJSON(device.j_fzrs,{}) : device.j_fzrs;
           device.j_mt_workers = typeof device.j_mt_workers == 'string' ? util.parseJSON(device.j_mt_workers,{}) : device.j_mt_workers;
           device.j_location = typeof device.j_location == 'string' ? util.parseJSON(device.j_location,{}) : device.j_location;
           device.j_param = typeof device.j_param == 'string' ? util.parseJSON(device.j_param,{}) : device.j_param;
           device.j_region = typeof device.j_region == 'string' ? util.parseJSON(device.j_region,{}) : device.j_region;
           device.j_extra_capacity = typeof device.j_extra_capacity == 'string' ? util.parseJSON(device.j_extra_capacity,{}) : device.j_extra_capacity;
           device.j_extra_capacity = device.j_extra_capacity ? device.j_extra_capacity : [];

           Object.keys(this.modal.device).forEach(key=>{
             this.modal.device[key] = device[key];
           })
           this.modal.device.id = device.id
           // this.modal.device = device;
           this.searchBandUser();
           this.modal.device.type = 0
           this.modal.device.sms_enable = device.sms_enable;
           this.modal.device.sms_limit = device.sms_limit;
           let len = device.j_floors.display.length;
           if (device.device_param.is_through_door === 1) {
             this.modal.totalFloor = len / 2;
           } else {
             this.modal.totalFloor = len;
           }

           if (device.type === 3) this.onRealDeviceSelect(device.vm_device_id);
           let j_location = util.parseJSON(this.modal.device.j_location, {});
           let choosedLocationIds = [];
           if (j_location.building) choosedLocationIds.push(j_location.building.id);
           if (j_location.unit) choosedLocationIds.push(j_location.unit.id);
           if (j_location.door) choosedLocationIds.push(j_location.door.id);
           setTimeout(() => {
             this.modal.choosedLocationIds = choosedLocationIds;
           }, 100)
           // this.modal.alarm_charger_mobile = [];
           this.modal.fzrs_mobile = [];
           this.modal.mt_worker_mbile = [];
           if (device.j_alarm_charger) {
             this.modal.alarm_charger_mobile = device.j_alarm_charger.map(charger => charger.mobile);
           }
           if (device.j_fzrs) {
             device.j_fzrs.forEach(fzr => this.modal.fzrs_mobile.push(fzr.mobile))
           }
           if (device.j_mt_workers) {
             device.j_mt_workers.forEach(mt => this.modal.mt_worker_mbile.push(mt.mobile))
           }
           // 编辑 住从电梯状态改变
           // // 设备可扩展能力 判断是否全选与非全选
           if (device.terminal_id) {
             if (!this.modal.device.j_extra_capacity) {
               this.indeterminate = false
               this.checkAll = false
             } else {
               if (this.modal.device.j_extra_capacity.length == this.modal.extra_capacity_list.length) {
                 this.checkAll = true
                 this.indeterminate = false
               } else if (this.modal.device.j_extra_capacity.length > 0) {
                 this.checkAll = false
                 this.indeterminate = true
               } else {
                 this.indeterminate = false
                 this.checkAll = false
               }
             }
           }
           // }
           if(this.modal.device.factory_cid){
             this.loadPusherSchemeConfigByFactoryCid(this.modal.device.factory_cid)
             if(this.modal.device.push_scheme_code){
               this.chooseSelect(this.modal.device.push_scheme_code);
             }
           }else{
             this.loadPusherSchemeConfig();
           }

           // console.log("this.search.factory_cid.values:",this.search.factory_cid.values);
           // this.remoteSearchFactoryBranch("", "replace");
           // let factoryCompany = this.search.factory_cid.values.find(elem => elem.id === this.modal.device.factory_cid) ;
           // if(factoryCompany){
           //   this.remoteSearchFactory(factoryCompany.name);
           // }
           // console.log(this.modal.device);
         }
       })


       this.modal.show = true;
    },
    searchBandUser() {
      let device_id = this.modal.device.id;
      util.ajax.get("device/getbanduser?device_id=" + device_id).then(res => {
        if (!res.code && res.data) {
          this.modal.bandUser = res.data;
        }
      })
    },
    // 取消绑定
    unBandUser(user, index) {
      util.ajax.get(`user/unbanduser?user_id=${user.user_id}&device_id=${this.modal.device.id}`).then(res => {
        if (!res.code) {
          this.$Message.success(this.$t("l.success"));
          this.modal.bandUser.splice(index, 1);
        }
      })
    },
    preLike(index) {
      let device = this.table.data[index];
      util.ajax.put('/device/like', {id: device.id}).then(res => {
        this.$Message.success(this.$t('l.remark173'));
        this.monitorList.likes.push(device.id);
      })
    },
    preUnlike(index) {
      let device = this.table.data[index];
      util.ajax.put('/device/unlike', {id: device.id}).then(res => {
        this.$Message.success(this.$t('l.no_focus'));
        this.monitorList.likes.splice(this.monitorList.likes.indexOf(device.id), 1);
        if (this.monitorList.showMonitor) this.table.data.splice(index, 1);
      })
    },
    // preWarnConfig(device) {
    //   this.warnModal.list = [];
    //   if (device.factory_cid) {
    //     let config = this.partsLifeMap[device.factory_cid];
    //     if (config) {
    //       this.warnModal.id = device.id;
    //       let map = {}; // 电梯厂配置
    //       config.forEach(elem => {
    //         map[elem.id] = elem;
    //       })
    //       if (device.parts_life) {
    //         let parts_life = JSON.parse(device.parts_life);
    //         // 确保同步电梯厂配置
    //         if (config.length > parts_life.length) {
    //           let pmap = {};
    //           parts_life.forEach(elem => {
    //             pmap[elem.id] = elem;
    //           })
    //           Object.keys(map).forEach(id => {
    //             if (pmap[id]) {
    //               if (!pmap[id].hasOwnProperty("use_time")) {
    //                 pmap[id]["use_time"] = 0;
    //               }
    //               Object.assign(pmap[id], {
    //                 name: map[id].name,
    //                 limit_life: pmap[id].limit_life ? pmap[id].limit_life : map[id].limit_life
    //               });
    //               this.warnModal.list.push(pmap[id]);
    //             } else {
    //               this.warnModal.list.push({
    //                 id: id,
    //                 name: map[id].name,
    //                 limit_life: map[id].limit_life,
    //                 use_time: 0
    //               });
    //             }
    //           })
    //         } else {
    //           parts_life.forEach(elem => {
    //             let itemMap = map[elem.id];
    //             if (itemMap) {
    //               if (!elem.hasOwnProperty("use_time")) {
    //                 elem["use_time"] = 0;
    //               }
    //               Object.assign(elem, {
    //                 name: itemMap.name,
    //                 limit_life: elem.limit_life ? elem.limit_life : itemMap.limit_life
    //               });
    //               this.warnModal.list.push(elem);
    //             }
    //           })
    //         }
    //       } else {
    //         this.warnModal.list = config.map(elem => {
    //           elem.use_time = 0;
    //           return elem;
    //         });
    //       }
    //     }
    //     this.warnModal.show = true;
    //   } else {
    //     this.$Message.warning(this.$t("l.remark210"));
    //   }
    // },
    deleteDevice(id) {
      util.ajax.get("/device/deletebyid?id=" + id).then(res => {
        if (!res.code) {
          for (let i in this.table.data) {
            if (this.table.data[i].id == id) {
              this.table.data.splice(i, 1)
              this.$Message.success(this.$t('l.delete_success'))
              this.loadData(this.table.page.current, this.search)
              this.monitorList.likes.forEach((item, index) => {
                if (item == id) this.monitorList.likes.splice(index, 1)
                return
              })
            }
          }
        }
      })
    },
    getDeviceQrcode(device) {
      this.$Modal.info({
        title: '设备唯一加密码：' + device.aesIdCode,
        width: 260,
        okText: this.$t('l.close'),
        render: (h1) => {
          let canvas = h1('canvas');
          let printEle = h1('div', {attrs: {id: 'printCanvas'}}, [
            canvas,
            h1('h4', {
              style: {
                textAlign: 'center'
              }
            }, "")
          ])
          setTimeout(() => {
            QRCode.toCanvas(canvas.elm, device.aesIdCode, {
              width: 220,
              height: 220
            }, (e) => {
            })
          }, 300)
          let aaa = h1('div', [
            printEle, h1('Button', {
              on: {
                click: () => {
                  Print({
                    printable: 'printCanvas',
                    type: 'html',
                    scanStyles: true
                  })
                }
              }
            }, this.$t('l.print'))
          ]);
          return aaa;
        }
      })


    },
    loadLikes() {
      util.ajax.get('/device/getlikes').then(res => {
        this.monitorList.likes.push(...res.data);
      })
    },
    remoteSearchCommunity(value) {
      if (!value.trim()) return;
      this.modal.searchLoading.community_id = true;
      util.ajax.get('/device/searchoption', {
        params: {
          table: 't_community',
          field: 'name',
          value: '%' + value + '%'
        }
      }).then(res => {
        this.modal.searchLoading.community_id = false;
        let existed = this.search.community_id.values.map(item => item.id)
        res.data.forEach(comm => {
          if (!existed.includes(comm.id)) {
            this.search.community_id.values.push(comm)
          }
        })
      })
    },
    remoteSearchRealDevices(value) {
      if (!value.trim()) return;
      this.modal.searchLoading.real_devices = true;
      util.ajax.get('/device/searchoption', {
        params: {
          table: 't_device',
          field: 'name',
          value: '%' + value + '%'
        }
      }).then(res => {
        this.modal.searchLoading.real_devices = false;
        let existed = this.realDevices.map(item => item.id)
        res.data.forEach(comm => {
          if (!existed.includes(comm.id)) {
            this.realDevices.push(comm)
          }
        })
      })
    },
    // 选择电梯可见公司 触发
    remoteSearchFactoryBranch(value, action) {
      console.log("调用 remoteSearchFactoryBranch ",value,action);
      value = value.trim();
      console.log(this.modal.device.factory_cid);
      if (!action && !value) return;
      if (!this.modal.device.factory_cid) return;
      this.modal.searchLoading.factoryBranch = true;

      // 获取 搜索条件
      util.ajax.get('/device/searchoption', {
        params: {
          table: 't_depart',
          field: 'name',
          value: '%' + value + '%',
          other: JSON.stringify({
            pid: this.modal.device.factory_cid,
            type: 0,
            role_id: roleTypes.ELEV_FACTORY
          })
        }
      }).then(res => {
        this.modal.searchLoading.factoryBranch = false;
        if (action === 'replace') this.search.factory_branch.values = [];
        let existed = this.search.factory_branch.values.map(item => item.id)
        res.data.forEach(comm => {
          if (!existed.includes(comm.id)) {
            this.search.factory_branch.values.unshift(comm)
          }
        })
      })

    // 2025年8月1日   根据电梯厂ID  获取电梯厂对应的推送方案
    this.loadPusherSchemeConfigByFactoryCid(this.modal.device.factory_cid);


    },
    remoteSearchFactory(value) {
      if (!value.trim()) return;
      const num = Number(value);
      if(!isNaN(num) && typeof num === 'number'){
        return;
      }
      console.log("触发 remoteSearchFactory：",value);
      this.modal.searchLoading.member = true;
      util.ajax.get('/device/searchoption', {
        params: {
          table: 't_depart',
          field: 'name',
          value: '%' + value.trim() + '%',
          other: JSON.stringify({
            pid: 0,
            type: 0,
            role_id: roleTypes.ELEV_FACTORY
          })
        }
      }).then(res => {
        this.modal.searchLoading.member = false;
        let existed = this.search.factory_cid.values.map(item => item.id)
        res.data.forEach(comm => {
          if (!existed.includes(comm.id)) {
            this.search.factory_cid.values.push(comm)
          }
        })
      })
    },
    remoteSearchMT(value) {
      if (!value.trim()) return;
      this.modal.searchLoading.mt = true;
      util.ajax.get('/device/searchoption', {
        params: {
          table: 't_depart',
          field: 'name',
          value: '%' + value.trim() + '%',
          other: JSON.stringify({
            type: 0,
            role_id: roleTypes.MT_COMPANY
          })
        }
      }).then(res => {
        this.modal.searchLoading.mt = false;
        let existed = this.search.mt_cid.values.map(item => item.id)
        res.data.forEach(comm => {
          if (!existed.includes(comm.id)) {
            this.search.mt_cid.values.push(comm)
          }
        })
      })
    },
    remoteSearchMTWorker(value) {
      if (!value) {
        return new Promise((resolve, reject) => {
          resolve()
        });
      }
      let list = this.search.j_mt_woker.values;
      list.splice(0, list.length);
      if (!value) return;
      this.modal.searchLoading.mt_worker = true;
      return util.ajax.get('/user/listofcompany', {
        params: {
          companyId: value
        }
      }).then(res => {
        this.modal.searchLoading.mt_worker = false;
        // res.data.forEach(worker => {
        //     worker.name = worker.realname;
        // })
        // list.push(...res.data);
      })
    },
    remoteSearchAD(value) {
      if (!value.trim()) return;
      this.modal.searchLoading.ad = true;
      util.ajax.get('/device/searchoption', {
        params: {
          table: 't_depart',
          field: 'name',
          value: '%' + value + '%',
          other: JSON.stringify({
            type: 0,
            role_id: roleTypes.AD
          })
        }
      }).then(res => {
        this.modal.searchLoading.ad = false;
        let existed = this.search.ad_cid.values.map(item => item.id)
        res.data.forEach(comm => {
          if (!existed.includes(comm.id)) {
            this.search.ad_cid.values.push(comm)
          }
        })
      })
    },
    addAlarm(charger) {
      this.search.j_alarm_charger.values.push(charger);
      this.modal.alarm_charger_mobile.push(charger.mobile);
    },
    addFzr(fzr) {
      this.search.j_fzrs.values.push(fzr);
      this.modal.fzrs_mobile.push(fzr.mobile);
    },
    addMtWorker(mt) {
      this.search.j_mt_woker.values.push(mt);
      this.modal.mt_worker_mbile.push(mt.mobile);
    },
    addAlarmCharger() {
      if (this.modal.alarm_charger_mobile.length > 2) {
        this.$Message.warning(this.$t("l.remark193"))
        return;
      }
      let charger = {
        name: '',
        mobile: ''
      }
      this.$Modal.confirm({
        render: (h) => {
          return h('div', [
            h('h3', {}, this.$t('l.add_alarm_mobile')),
            h('Form', {
                  props: {
                    'label-width': 80
                  },
                  style: {
                    marginTop: '10px'
                  }
                },
                [
                  h('FormItem', {
                    props: {
                      label: this.$t('l.name')
                    }
                  }, [h('Input', {
                    props: {
                      value: charger.name,
                      placeholder: this.$t('l.remark39')
                    },
                    on: {
                      input: (val) => {
                        charger.name = val
                      }
                    }
                  })]),
                  h('FormItem', {
                    props: {
                      label: this.$t('l.mobile')
                    }
                  }, [h('Input', {
                    props: {
                      value: charger.mobile,
                      placeholder: this.$t('l.remark41')
                    },
                    on: {
                      input: (val) => {
                        charger.mobile = val
                      }
                    }
                  })])
                ])
          ])
        },
        onOk: () => {
          if (!charger.name || !charger.mobile) {
            this.$Message.warning(this.$t('l.remark90'));
            return;
          }
          if (!(/^1[3456789]\d{9}$/.test(charger.mobile))) {
            this.$Message.warning(this.$t('l.remark91'));
            return;
          }
          this.search.j_alarm_charger.values.push(charger);
          this.modal.alarm_charger_mobile.push(charger.mobile);
          this.modal.device.j_alarm_charger.push(charger);
        }
      })
    },
    addAlarmChargerForImport() {
      if (this.modal.alarm_charger_mobile.length > 2) {
        this.$Message.warning(this.$t("l.remark193"))
        return;
      }

      let charger = {
        name: '',
        mobile: ''
      }
      this.$Modal.confirm({
        render: (h) => {
          return h('div', [
            h('h3', {}, this.$t('l.add_alarm_mobile')),
            h('Form', {
                  props: {
                    'label-width': 80
                  },
                  style: {
                    marginTop: '10px'
                  }
                },
                [
                  h('FormItem', {
                    props: {
                      label: this.$t('l.name')
                    }
                  }, [h('Input', {
                    props: {
                      value: charger.name,
                      placeholder: this.$t('l.remark39')
                    },
                    on: {
                      input: (val) => {
                        charger.name = val
                      }
                    }
                  })]),
                  h('FormItem', {
                    props: {
                      label: this.$t('l.mobile')
                    }
                  }, [h('Input', {
                    props: {
                      value: charger.mobile,
                      placeholder: this.$t('l.remark41')
                    },
                    on: {
                      input: (val) => {
                        charger.mobile = val
                      }
                    }
                  })])
                ])
          ])
        },
        onOk: () => {
          if (!charger.name || !charger.mobile) {
            this.$Message.warning(this.$t('l.remark90'));
            return;
          }
          if (!(/^1[3456789]\d{9}$/.test(charger.mobile))) {
            this.$Message.warning(this.$t('l.remark91'));
            return;
          }

          if(typeof this.excel_file.DetailsForm[0].j_alarm_charger === "string"){
            this.excel_file.DetailsForm[0].j_alarm_charger = JSON.parse(this.excel_file.DetailsForm[0].j_alarm_charger);
          }
          this.excel_file.DetailsForm[0].j_alarm_charger.push(charger);
          this.excel_file.DetailsForm[0].j_alarm_charger = JSON.stringify(this.excel_file.DetailsForm[0].j_alarm_charger);

          // 添加
          this.search.j_alarm_charger.values.push(charger);
          this.modal.alarm_charger_mobile.push(charger.mobile);

        }
      })
    },
    alarmDesc() {
      this.$Modal.info({
        title: this.$t("l.alarm_description"),
        okText: this.$t("l.close"),
        render: (h) => {
          return h('div', [
            h("p", {}, "1、" + this.$t("l.explain18")),
            h("p", {}, "2、" + this.$t("l.explain19")),
            h("p", {}, "3、" + this.$t("l.explain20")),
            h("p", {}, "4、" + this.$t("l.explain23"))
          ])
        },
      })
    },

    // 点击选择位置  王欢  2025年10月29日
    clickSelectLocation(){
      this.locationModal.show = true;
      if(this.modal.device.latitude || this.modal.device.longitude){
        this.locationModal.center = [this.modal.device.longitude,this.modal.device.latitude];
      }

    },
    addElevatorSelectAlarmUser(mobiles) {
      if (mobiles.length > 2) {
        this.modal.alarm_charger_mobile = mobiles.slice(0, 2);
        this.$Message.error(this.$t('l.remark193'));
        return;
      }
      this.modal.alarm_charger_mobile = mobiles;
    },
    checkInput(e) {
      let prohibitInput = ["-", "e", "+", "E", "."];
      console.log(e.key, prohibitInput.includes(e.key));
      if (prohibitInput.includes(e.key)) {
        e.preventDefault()
      }
    },
    addFzrs() {
      let fzr = {
        name: '',
        mobile: ''
      }
      this.$Modal.confirm({
        render: (h) => {
          return h('div', [
            h('h3', this.$t('l.add_principal')),
            h('Form', {
                  props: {
                    'label-width': 80
                  },
                  style: {
                    marginTop: '10px'
                  }
                },
                [
                  h('FormItem', {
                    props: {
                      label: this.$t('l.name')
                    }
                  }, [h('Input', {
                    props: {
                      value: fzr.name,
                      placeholder: this.$t('l.remark39')
                    },
                    on: {
                      input: (val) => {
                        fzr.name = val
                      }
                    }
                  })]),
                  h('FormItem', {
                    props: {
                      label: this.$t('l.mobile')
                    }
                  }, [h('Input', {
                    props: {
                      value: fzr.mobile,
                      placeholder: this.$t('l.remark41')
                    },
                    on: {
                      input: (val) => {
                        fzr.mobile = val
                      }
                    }
                  })])
                ])
          ])
        },
        onOk: () => {
          if (!fzr.name || !fzr.mobile) {
            this.$Message.warning(this.$t('l.remark90'));
            return;
          }
          if (!(/^1[3456789]\d{9}$/.test(fzr.mobile))) {
            this.$Message.warning(this.$t('l.remark91'));
            return;
          }
          this.search.j_fzrs.values.push(fzr);
          this.modal.fzrs_mobile.push(fzr.mobile);
          this.modal.device.j_fzrs.push(fzr);

        }
      })
    },
    // 新建维保负责人
    addMtWorkers() {
      let mt = {
        name: '',
        mobile: ''
      }
      this.$Modal.confirm({
        render: (h) => {
          return h('div', [
            h('h3', this.$t('l.add_maintenance')),
            h('Form', {
                  props: {
                    'label-width': 80
                  },
                  style: {
                    marginTop: '10px'
                  }
                },
                [
                  h('FormItem', {
                    props: {
                      label: this.$t('l.name')
                    }
                  }, [h('Input', {
                    props: {
                      value: mt.name,
                      placeholder: this.$t('l.remark39')
                    },
                    on: {
                      input: (val) => {
                        mt.name = val
                      }
                    }
                  })]),
                  h('FormItem', {
                    props: {
                      label: this.$t('l.mobile')
                    }
                  }, [h('Input', {
                    props: {
                      value: mt.mobile,
                      placeholder: this.$t('l.remark41')
                    },
                    on: {
                      input: (val) => {
                        mt.mobile = val
                      }
                    }
                  })])
                ])
          ])
        },
        onOk: () => {
          if (!mt.name || !mt.mobile) {
            this.$Message.warning(this.$t('l.remark90'));
            return;
          }
          if (!(/^1[3456789]\d{9}$/.test(mt.mobile))) {
            this.$Message.warning(this.$t('l.remark91'));
            return;
          }
          this.search.j_mt_woker.values.push(mt);
          this.modal.mt_worker_mbile.push(mt.mobile);
          this.modal.device.j_mt_workers.push(mt);

        }
      })
    },
    preJumpAddCommunity() {
      this.$Modal.confirm({
        title: this.$t('l.prompt'),
        content: this.$t('l.remark93'),
        okText: this.$t('l.confirm'),
        cancelText: this.$t('l.cancel'),
        onOk: () => {
          this.$router.push({name: 'page_community'})
        }
      })
    },


    // 2025年10月20日 手动添加维保人
    preJumpAddMtPerson(){
      let mt = {
        name: '',
        mobile: ''
      }
      this.$Modal.confirm({
        render: (h) => {
          return h('div', [
            h('h3', this.$t('l.add_maintenance')),
            h('Form', {
                  props: {
                    'label-width': 80
                  },
                  style: {
                    marginTop: '10px'
                  }
                },
                [
                  h('FormItem', {
                    props: {
                      label: this.$t('l.name')
                    }
                  }, [h('Input', {
                    props: {
                      value: mt.name,
                      placeholder: this.$t('l.remark39')
                    },
                    on: {
                      input: (val) => {
                        mt.name = val
                      }
                    }
                  })]),
                  h('FormItem', {
                    props: {
                      label: this.$t('l.mobile')
                    }
                  }, [h('Input', {
                    props: {
                      value: mt.mobile,
                      placeholder: this.$t('l.remark41')
                    },
                    on: {
                      input: (val) => {
                        mt.mobile = val
                      }
                    }
                  })])
                ])
          ])
        },
        onOk: () => {
          console.log("mt:",mt);
          if (!mt.name || !mt.mobile) {
            this.$Message.warning(this.$t('l.remark90'));
            return;
          }
          if (!(/^1[3456789]\d{9}$/.test(mt.mobile))) {
            this.$Message.warning(this.$t('l.remark91'));
            return;
          }
          this.modal.mt_worker_mbile.push(mt.mobile);
          if(typeof this.excel_file.DetailsForm[0].j_mt_workers === "string"){
            this.excel_file.DetailsForm[0].j_mt_workers = JSON.parse(this.excel_file.DetailsForm[0].j_mt_workers);
          }

          this.search.j_mt_woker.values.push(mt);
          this.excel_file.DetailsForm[0].j_mt_workers.push(mt);
          // this.modal.mt_worker_mbile.push(mt.mobile);
          this.excel_file.DetailsForm[0].j_mt_workers = JSON.stringify(this.excel_file.DetailsForm[0].j_mt_workers);

        }
      })
    },

    /**
     * 请求参数封装
     *
     * */
    getListRequestParams(page, search = "") {
      let params = {
        page: page || this.table.page.current,
        size: this.table.page.size,
        orderKey: this.table.page.sortKey,
        orderMethod: this.table.page.sortMethod,
        keyword: this.table.page.keyword,
        noStatus: false
      };
      if (Object.keys(search).find(key => search[key].selected.length)) {   //  按条件筛选
        Object.keys(search).forEach(field => {
          if (search[field].selected.length) {
            if (field != "end_date_range") {
              params[field] = search[field].selected.map(index => search[field].values[index].id);
            } else {
              params[field] = search[field].selected;
            }
          }
        })
        params.noStatus = true;
      }
      return params;
    },

    loadData(page = 1, search = "") {
      this.searchLoading = true;
      let now = Date.now();
      if (now - this.table.loadTime < 1000) return;
      this.table.loadTime = now;
      this.table.loading = true;
      if (this.monitorList.showMonitor) { // 多梯监控
        util.ajax.get('/device/listlike').then(res => {
          this.setPage({list: res.data})
          monitorUtil.refreshList(res.data);
          monitorUtil.ws.on('up_report_status', this.onMonitorMessage.bind(this), 1);
          this.table.loading = false;
          this.searchLoading = false;
        })
      } else { // 正常列表
        if (!this.monitorList.showMonitor) monitorUtil.destroy(); // 返回列表页
        ws.addSubscibeToLift([], 'subscribe');
        util.ajax.post('/device/list', this.getListRequestParams(page, search)).then(res => {
          this.table.loading = false;
          setTimeout(()=>{
            this.searchLoading = false;
          },100)
          this.setPage(res.data);
          let darr = res.data.list.filter(elem => elem && elem.terminal_id && elem.terminal_id.startsWith("E")).map(item => (item.terminal_id));
          if (darr && darr.length) { // iecs设备获取、更新状态
            ws.addSubscibeToLift(darr, 'subscribe');
            ws.sendMessage('get_last_iecs', darr);
          }
          let idArr = res.data.list.map(device => device.id);
          let cidArr = res.data.list.filter(device => device.community_id).map((de) => de.community_id);
          let fidArr = [...new Set(res.data.list.filter(device => device.factory_cid).map((de) => de.factory_cid))];
          return {idArr, cidArr, fidArr};
        }).then(({idArr, cidArr, fidArr}) => {
          // 故障状态设置
          util.ajax.get('/fault/listbydevice', {
            params: {
              ids: idArr.join(','),
            }
          }).then(res1 => {
            this.setDeviceFaults(res1.data);
          })
          //   小区名字
          util.ajax.get('/community/listbydevice', {
            params: {
              ids: cidArr.join(','),
            }
          }).then(res1 => {
            this.setDeviceCommunityName(res1.data);
          })
          //   获取电梯厂部件配置信息
          // util.ajax.get("settings/getpartslist", {
          //   params: {
          //     ids: fidArr.join(','),
          //   }
          // }).then(res => {
          //   if (!res.code) {
          //     if (res.data) {
          //       res.data.forEach(elem => {
          //         this.partsLifeMap[elem['factory_cid']] = typeof elem.config == "string" ? JSON.parse(elem.config) : elem.config;
          //       })
          //     }
          //   }
          // })
        })
      }
    },
    onMonitorMessage(message) {
      let deviceName = message.deviceName;
      let statusContent = message.data;
      let device = this.deviceMap[deviceName];
      if (!device) return;
      // 设置楼层对应
      Object.keys(statusContent).forEach(field => {
        if ((field == "CAN_fault" || field == "run_fault") && statusContent[field] == 1) {
          this.$set(device, 'broken', true);
        } else if (field == "floor_current" && device.j_floors.display) {
          this.$set(device.current_status, "floor_current", device.j_floors.display[statusContent[field]]);
        } else {
          this.$set(device.current_status, field, statusContent[field]);
        }
      })
      this.table.data.forEach(de => {
        if (de.id == device.id && device.broken) {
          this.$set(de, 'broken', true);
        } else {
          this.$set(de, 'broken', false);
        }
      })
      // this.setDeviceFaults();
    },
    onOnlineStatusMessage(message) {
      let device = this.deviceMap[message.deviceName];
      if (!device) return;
      // MARK_MODIFY_ONLINE20200525
      device.j_param.status = message.status;
      device.online = message.status === 'online' ? 1 : 0;  // MARK_MODIFY_ONLINE20200525
      // this.$set(device, 'online', device.j_param.status === 'online');
      this.$set(device, 'online', device.online === 1);  // MARK_MODIFY_ONLINE20200525
      // this.$set(device, 'broken', device.j_param.status?device.j_param.status.fault === 1:0);  // MARK_MODIFY_ONLINE20200525
    },
    setPage(pageInfo) {
      if (pageInfo) {
        let ids = [];
        pageInfo.list.forEach(device => {
          ids.push(device.id);
          util.parseJSONResult(device);
          if (device) {
            device.device_param = util.parseJSON(device.device_param);
            device.transtionShow = false;
            this.$set(device, 'online', device.online);
            this.$set(device, 'current_status', {});
          }
        })
        this.table.data = pageInfo.list;
        this.table.page.current = pageInfo.pageNumber;
        this.table.page.total = pageInfo.totalRow;
      }
    },
    setDeviceFaults(faults) {
      let faultMap = {};
      if (faults) {
        faults.forEach(fault => {
          faultMap[fault.device_id] = true;
        })
      }
      this.table.data.forEach(device => {
        if (faultMap[device.id]) {
          this.$set(device, 'broken', true);
        }
      })
    },
    setDeviceCommunityName(cs) {
      let communityMap = {};
      if (cs) {
        cs.forEach(c => {
          communityMap[c.id] = c.name;
        })
      }
      this.table.data.forEach(device => {
        if (communityMap[device.community_id]) {
          this.$set(device, 'community_name', communityMap[device.community_id]);
        }
      })
    },
    loadOptions() {
      this.search.community_id.values = [];
      this.search.j_alarm_charger.values = [];
      this.search.j_fzrs.values = []
      this.search.pusher_type.values = []
      this.search.j_mt_woker.values = [];
      this.search.factory_cid.values = [];
      this.search.factory_branch.values = [];
      this.search.mt_cid.values = [];
      this.search.ad_cid.values = [];

      // 2025年6月27日  拆分请求 一个请求有点慢  王欢

      util.ajax.get('/device/getVCompany').then(res => {
        if (res.data) {
          this.search.factory_cid.values = [];
          this.search.factory_branch.values = [];
          this.search.mt_cid.values = [];
          this.search.ad_cid.values = [];
          let myCompany = this.$store.state.user.user.company;
          if (!res.data.company.map(comp => comp.id).includes(myCompany.id)) {
            res.data.company.push(myCompany);
          }
          res.data.company.map(company => {
            switch (company.role_id) {
              case roleTypes.AD:
                this.search.ad_cid.values.push(company);
                break;
              case roleTypes.MT_COMPANY:
                this.search.mt_cid.values.push(company);
                break;
              case roleTypes.ELEV_FACTORY:
              case roleTypes.CONSUMER:
                if (!company.pid) this.search.factory_cid.values.push(company);
                else this.search.factory_branch.values.push(company);
                break;
            }
          })
        }
      })

      util.ajax.get('/device/getVCommunity').then(res => {
        if (res.data) {
          this.search.community_id.values = res.data.community;
        }

      })

      util.ajax.get('/device/getVAlarmAndFzrAndMt').then(res => {
        if (res.data) {
          this.search.j_alarm_charger.values = [];
          this.search.j_fzrs.values = []
          this.search.j_mt_woker.values = [];
          //所有告警人
          res.data.alarm_chargers.forEach(man => {
            if (man && man.mobile) {
              man.id = man.mobile;
              if (!this.chargerMap[man.mobile]) this.search.j_alarm_charger.values.push(man);
            }
          });
          //所有负责人
          if (res.data.fzrs) {
            res.data.fzrs.forEach(mans => {
              let manArr = JSON.parse(mans);
              if (manArr && manArr.length) {
                manArr.forEach(man => {
                  if (man && man.mobile) {
                    man.id = man.mobile;
                    if (!this.fzrMap[man.mobile]) this.search.j_fzrs.values.push(man);
                  }
                });
              }
            });
          }
          // 所有维保人员
          res.data.j_mt_workers.forEach(mans => {
            let manArr = JSON.parse(mans);
            if (manArr && manArr.length) {
              manArr.forEach(man => {
                if (man && man.mobile) {
                  man.id = man.mobile;
                  if (!this.mtWorkersMap[man.mobile]) this.search.j_mt_woker.values.push(man);
                }
              });
            }
          });

        }
      })

      util.ajax.get('/device/getVPushers').then(res => {
        if (res.data) {
          this.search.pusher_type.values = []
          // 推送平台类型
          this.search.pusher_type.values = res.data.pushers.map(elem => {
            elem.id = elem.label;
            return elem;
          });
        }
      })
    },


    // 加载所有推送平台方案配置
    loadPusherSchemeConfig() {
      util.ajax.get('/push/getAllScheme').then(res => {
        let schemeRecords = res.data;  // 所有方案记录列表
        if (schemeRecords && schemeRecords.length) {
          this.pusherModal.schemeConfigList = schemeRecords;
          this.modal.filed_list = [];
          let item = schemeRecords.find(e => e.code === this.modal.device.push_scheme_code);
          if (item) {
            let configArr = JSON.parse(item.config);
            if (configArr) {
              configArr.forEach(item => {
                if (item.is_elevator_field === 1) {
                  this.modal.filed_list.push(item);
                }
              })
            }
            let label = item.push_label;
            this.getPusherFileByLabel(label);

          }
        }
      })
    },
    //  loadPusherSchemeConfigByCode(code){
    //   this.pusherModal.schemeConfigList =[];
    //   return new Promise((resolve,reject) =>{
    //     if(code){
    //       util.ajax.get('/push/getPusherInfoByCode?code='+code).then(res => {
    //         let schemeRecords = res.data;  // 所有方案记录列表
    //         if (schemeRecords && schemeRecords.length) {
    //           this.pusherModal.schemeConfigList = schemeRecords;
    //           this.modal.filed_list = [];
    //           let item = schemeRecords.find(e => e.code === this.modal.device.push_scheme_code);
    //           if (item) {
    //             let configArr = JSON.parse(item.config);
    //             if (configArr) {
    //               configArr.forEach(item => {
    //                 if (item.is_elevator_field === 1) {
    //                   this.modal.filed_list.push(item);
    //                 }
    //               })
    //             }
    //             let label = item.push_label;
    //             this.getPusherFileByLabel(label);
    //           }
    //         }
    //         resolve();
    //       })
    //
    //     }
    //     resolve();
    //   });
    //
    // },

    loadPusherSchemeConfigByFactoryCid(factoryCid){
      if(factoryCid){
        util.ajax.get('/push/getPusherInfoByFactoryCid?factoryCid='+factoryCid).then(res => {
          let schemeRecords = res.data;  // 所有方案记录列表
          this.modal.filed_list = [];
          if (schemeRecords && schemeRecords.length) {
            this.pusherModal.schemeConfigList = schemeRecords;
            let item = schemeRecords.find(e => e.code === this.modal.device.push_scheme_code);
            if (item) {
              let configArr = JSON.parse(item.config);
              if (configArr) {
                configArr.forEach(item => {
                  if (item.is_elevator_field === 1) {
                    this.modal.filed_list.push(item);
                  }
                })
              }
              let label = item.push_label;
              this.getPusherFileByLabel(label);

            }
          }
        })
      }

    },


    // 加载推送平台配置
    loadPusherConfig() {
      this.pusherModal.spin = true;
      // 定义属性优先级顺序
      const priority = ['username', 'password'];
      util.ajax.get('/push/getAllPusher').then(res => {
        let pusherList = res.data;  // 推送平台配置列表
        if (pusherList) {
          this.pusherModal.configList = pusherList.map(item => {
            let config = JSON.parse(item.j_config)
            if (item.docs) {
              item.docsArr = item.docs.split(",").map(docUrl => {
                return  {fileName: docUrl, url: "https://static.diantiyun.com/upload/push/" + docUrl};
              })
            }

            config.forEach(e => {
              e.value = "";
            })

            item.config = config.sort((a,b)=>{

              const indexA = priority.indexOf(a.map_field);
              const indexB = priority.indexOf(b.map_field);

              if (indexA === -1 && indexB === -1) return 0; // 都不在优先级中，保持原顺序
              if (indexA === -1) return 1; // a 不在优先级中，b 优先
              if (indexB === -1) return -1; // b 不在优先级中，a 优先
              return indexA - indexB; // 都在优先级中，按定义顺序排序

            })

            //  子账号信息
            item.children = [];
            return item;
          });
          //   加载方案
          util.ajax.get('/push/getSchemeConfig').then(res => {
            this.pusherModal.spin = false;
            let schemeRecords = res.data;  // 方案记录列表
            if (schemeRecords && schemeRecords.length) {  // 当前电梯厂存在方案
              let map = {};
              schemeRecords.forEach(item => {
                map[item.push_label] = item;
                item.children = item.children.map(e => {
                  e.config = JSON.parse(e.config);
                  return e;
                });

              })
              this.pusherModal.configList.forEach(item => {
                let label = item.label;
                if (map[label]) { // 找到对应平台
                  item.children = map[label].children;
                  let config = JSON.parse(map[label].config);
                  item.config = config.sort((a,b)=>{
                    const indexA = priority.indexOf(a.map_field);
                    const indexB = priority.indexOf(b.map_field);
                    if (indexA === -1 && indexB === -1) return 0; // 都不在优先级中，保持原顺序
                    if (indexA === -1) return 1; // a 不在优先级中，b 优先
                    if (indexB === -1) return -1; // b 不在优先级中，a 优先
                    return indexA - indexB; // 都在优先级中，按定义顺序排序
                  })

                  item.code = map[label].code;
                }
              });
            }
          })

        }
      })
    },

    onSearch() {
      this.loadData(1, this.search);
    },
    addBatch(param) {
      let item = param.item
      if (this.batch.list.length > 0) {
        for (let i in this.batch.list) {
          if (item.id == this.batch.list[i].id) {
            this.$Message.warning($t('l.remark94'));
            return
          }
        }
      }
      this.batch.list.push(param.item)
    },
    detach(id) {
      for (let i in this.batch.list) {
        if (id == this.batch.list[i].id) {
          this.batch.list.splice(i, 1)
        }
      }
    },

    // 打开推送平台设置
    openPusherConfig() {
      this.pusherModal.show = true;
      this.loadPusherConfig();
    },

    // 批量操作
    batchPusherConfig() {
      this.batchPusherModal.show = true;
      this.batchPusherModal.selectedDevices = [];
      this.loadPusherSchemeConfig();
      this.loadDeviceForPusher();
    },

    openMap(){
      this.mapDrawer.show=true;
      // this.loadAllDeviceMapMarkers();
    },

    toggleLikes() {
      if (this.monitorList.likes.length > 0) {  // 真正的选择关注的设备才能发请求
        this.monitorList.showMonitor = true;
        this.loadData(this.table.page.current, this.search);
      } else {  //  没有关注的设备
        if (!this.monitorList.showMonitor) {
          this.$Message.warning(this.$t('l.remark95'));
        }
      }
    },
    back_devices() {
      this.monitorList.showMonitor = false;
      this.loadData(this.table.page.current, this.search);
    },
    onRealtimeFault(message) {
      let device = this.deviceMap[message.deviceName];
      if (!device) return;
      device.broken = true;
    },
    onRealtimeSolveFault(message) {
      let device = this.deviceMap[message.deviceName];
      if (!device) return;
      device.broken = false;
    },
    mapDrawerVisibleChange(val){
      this.mapDrawer.isAddMarker = val;
    },
    changeRadio() {
      this.$refs['modal'].resetFields();
    },
    // 2025年7月21日  王欢 如果选择了一个推送配置方案 只要不是 “” 需要将当前方案中的 电梯基本信息以外的字段展示出来并填写
    chooseSelect(code) {
      this.modal.filed_list = [];
      let item = this.pusherModal.schemeConfigList.find(e => e.code === code);
      if(item){
        this.modal.device.regulatory_field.way = item.push_label;
        let configArr = JSON.parse(item.config);
        // 便利所有
        let label = item.push_label;
        if (configArr) {
          configArr.forEach(item => {
            if (item.is_elevator_field === 1) {  // 是电梯信息字段
              this.modal.filed_list.push(item);
            }
          })
        }
        //   选中后吧文件显示出来
        this.getPusherFileByLabel(label);
      }

    },

    getPusherFileByLabel(label) {
      util.ajax.get("push/getPusherFile", {
        params: {
          label
        }
      }).then(res => {
        if (res.data && res.data.length) {
          res.data.forEach(fileName => {
            this.pusherModal.currentPusherFile.push({
              name: fileName,
              url: 'https://static.diantiyun.com/upload/push/' + fileName
            });
          })
        }
      })
    },

    chooseSelectOfBatchPusher(code) {
      let currentItem = this.pusherModal.schemeConfigList.find(item => item.code === code);
      let label = currentItem.push_label;
      this.getPusherFileByLabel(label);
    },

    searchBlur() {
      if (!this.table.page.keyword) this.loadData(1, this.search);
    },
    beforeUploadFile(file) {
      if (!file) {
        this.$Message.warning(this.$t('l.remark98'))
        return false
      }
      let formData = new FormData();
      formData.append("file", file);   // 文件对象
      this.loading.upload = true;
      // this.$Message.loading({content:"文件上传中...",duration: 1000})
      return new Promise((resolve, reject) => {
        util.ajax.post('device/upload_deviceInfo', formData).then(res => {
          this.loading.upload = false;
          if (!res.code) {
            this.$Message.success(this.$t('l.upload_success'))
            this.loadData();
          }else{

          }
        })
        resolve();
      })
    },


    openSetExcelExport() {
      this.modal.alarm_charger_mobile = [];
      this.excel_file.DetailsForm = this.getData.map(elem => {
        elem.j_alarm_charger = JSON.stringify(elem.j_alarm_charger);
        elem.j_mt_workers = JSON.stringify(elem.j_mt_workers);
        elem.j_alarm_charger = elem.j_alarm_charger.replace(/,/g, "|");
        elem.j_mt_workers = elem.j_mt_workers.replace(/,/g, "|");
        return elem;
      })
      this.excel_file.show = true;
    },
    exportData() {
      this.$Modal.confirm({
        title: this.$t('l.warn'),
        content: this.$t('l.remark99'),
        onOk: () => {
          let data = this.getData.map(elem => {
            elem.j_alarm_charger = JSON.stringify(elem.j_alarm_charger);
            elem.j_mt_workers = JSON.stringify(elem.j_mt_workers);
            elem.j_alarm_charger = elem.j_alarm_charger.replace(/,/g, "|");
            elem.j_mt_workers = elem.j_mt_workers.replace(/,/g, "|");
            return elem;
          })
          // this.$refs.table.exportCsv({
          //     filename: this.$t('l.remark100'),
          //     data: data,
          // });
        }
      })
      this.excel_file.show = false;

    },

    /**
     * 按照结果导出
     *
     * */

    exportExcelOfResult() {
      this.$Modal.warning({
        title: this.$t('l.warn'),
        content: this.$t('l.remark232'),
        onOk: () => {
          this.exportDataLoading = true;
          axios({
            // headers: {
            //     "Authorization": localStorage.getItem("token"),
            // },
            responseType: "blob",
            method: "post",
            url: "https://api.diantiyun.com/device/export",
            // url: "http://localhost:8181/device/export",
            data: this.getListRequestParams(1, this.search),
          }).then(response => {
            this.exportDataLoading = false;
            //这里面是请求成功以后下载文件的方法
            let a = document.createElement('a');
            //ArrayBuffer 转为 Blob
            let blob = new Blob([response.data], {type: "application/vnd.ms-excel;charset=utf-8"});
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", '电梯云导出数据.xls');
            a.click();
          });
        }
      })
    },

    // loadRegionData() {
    //   this.modal.push_way = [];
    //   util.ajax.get('/push/accesspermit').then(res => {
    //     if (res.data && res.data.length) {
    //       this.modal.push_way = res.data.map(elem => {
    //         elem.j_factory = JSON.parse(elem.j_factory);
    //         elem.j_config = JSON.parse(elem.j_config);
    //         return elem;
    //       });
    //     }
    //   })
    // },
    // loadLocationMarks() {
    //   util.ajax.get('/device/markers').then(res => {
    //     if (!res.code) {
    //       this.mapDrawer.markers = res.data ? res.data : [];
    //       if (this.mapDrawer.markers.length) {
    //         let center = this.mapDrawer.markers[0];
    //         this.mapDrawer.center = {lng: center.longitude, lat: center.latitude}
    //         this.mapDrawer.zoom = 10
    //       }
    //     }
    //   })
    // },
    updateDeviceStatus(message) {
      let data = message.data;
      if (message.deviceName && message.deviceName.startsWith("E")) {
        if (this.deviceMap[message.deviceName]) {
          this.$set(this.deviceMap[message.deviceName], 'broken', !!data.fault_exist);
          this.$set(this.deviceMap[message.deviceName], 'online', 1);
        }
      }
    },

    // 点击地图 添加点 事件
    onMapClickAddMarker(data){
      const {lng,lat,address} = data;
      console.log("触发 onMapClickAddMarker ",data);
        this.modal.device.latitude = lat;
        this.modal.device.longitude = lng;
        this.modal.device.address = address
    },

    //  保存部件寿命配置
    onSaveWarnParts(zero = false, index = -1) {
      let device_id = this.warnModal.id;
      if (this.warnModal.list.length) {
        let data = this.warnModal.list.map(elem => {
          // delete elem.name;
          return elem;
        })
        util.ajax.post("device/updateparts", {
          id: device_id,
          parts_life: data,
          index: -1
        }).then(res => {
          if (!res.code) {
            if (!zero) this.warnModal.show = false;
            this.$Message.success(this.$t("l.save_success"));
          }
        })
      }
      this.warnModal.show = false;
    },
    //  置零
    //     onZero(i,elem){
    //         elem.use_time = 0;
    //         this.warnModal.list.splice(i,1,elem);
    //         this.onSaveWarnParts(true,i);
    //     },


    // 2025年7月17日  王欢 新增推送平台设置
    onSavePusherConfig() {
      let len = this.pusherModal.configList.length;
      let submitList = [];
      if (len) {
        this.pusherModal.configList.forEach(item => {
          let children = item.children;
          let port = item.port;
          let configUsernameItem = item.config.find(e => e.hasOwnProperty("map_field") && e.map_field === "username");
          let configPasswordItem = item.config.find(e => e.hasOwnProperty("map_field") && e.map_field === "password");
          item.username = configUsernameItem ? configUsernameItem.value : '';
          item.password = configPasswordItem ? configPasswordItem.value : '';
          let push_label = item.label;
          if (children.length) {  // 存在子账号
            submitList.push(...children.map(e => {
              e.is_child = 1;
              let childConfigUsernameItem = e.config.find(el => el.hasOwnProperty("map_field") && el.map_field === "username");
              let childConfigPasswordItem = e.config.find(el => el.hasOwnProperty("map_field") && el.map_field === "password");
              e.username = childConfigUsernameItem ? childConfigUsernameItem.value : '';
              e.password = childConfigPasswordItem ? childConfigPasswordItem.value : '';
              e.label = push_label;
              e.port = port
              return e
            }));
          }
          submitList.push(item);
        })
        console.log("提交submitList：", submitList);
        if (submitList.length) {
          util.ajax.post("push/saveConfig", {
            list: submitList
          }).then(res => {
            if (!res.code) {
              this.$Message.success(this.$t("l.save_success"));
              this.pusherModal.show = false;
            } else {
              this.$Message.error(this.$t("l.save_success"));
            }
          })
        }

      }

    },

    // 每次选中表格中的电梯
    onSelectDeviceForPusher(selection, row) {
      this.batchPusherModal.selectedDevices.push(row.id);
    },

    // 取消选择某一项
    onCancelSelectDeviceForPusher: function (selection, row) {
      let index = this.batchPusherModal.selectedDevices.findIndex(id => id === row.id);
      if (index >= 0) {
        this.batchPusherModal.selectedDevices.splice(index, 1);
      }
    },

    // 每次选中所有表格中的电梯
    onSelectAllDeviceForPusher(selection) {
      this.batchPusherModal.selectedDevices.push(...selection.map(item => item.id))
      if (this.batchPusherModal.selectedDevices.length) {
        this.batchPusherModal.selectedDevices = [...new Set(this.batchPusherModal.selectedDevices)]
      }
    },
    // 每次取消选中所有表格中的电梯
    onCancelSelectAllDeviceForPusher(selection) {
      let removeIdsArr = this.batchPusherModal.table.data.map(item => item.id);  // 当前页所有id 都取消
      removeIdsArr.forEach(id => {
        let index = this.batchPusherModal.selectedDevices.findIndex(itemID => itemID === id);
        if (index >= 0) {
          this.batchPusherModal.selectedDevices.splice(index, 1);
        }
      })
    },

    // 2025年7月22日  推送平台加载电梯数据
    loadDeviceForPusher(page = 1) {
      this.batchPusherModal.table.loading = true;
      this.batchPusherModal.table.page.current = page;
      util.ajax.post('/device/listForPusher', this.batchPusherModal.table.page).then(res => {
        this.batchPusherModal.table.loading = false;
        this.batchPusherModal.table.data = res.data.list
        this.batchPusherModal.table.data = [];
        res.data.list.forEach(item => {
          item._checked = this.batchPusherModal.selectedDevices.includes(item.id);
          this.batchPusherModal.table.data.push(item);
        });
        this.batchPusherModal.table.page.current = res.data.pageNumber;
        this.batchPusherModal.table.page.total = res.data.totalRow;
      })
    },

    onBatchSavePusherConfig() {
      //   需要更新哪些设备
      if (!this.batchPusherModal.selectedDevices.length) {
        this.$Message.error(this.$t("l.remark249"));
        return
      }

      if(this.batchPusherModal.push_scheme_code  === '0'){
        this.$Message.error(this.$t("l.remark250"));
        return
      }

      this.$Modal.confirm({
        title:'警告',
        content:'确定提交修改后的方案？',
        onOk:()=>{
          this.batchPusherModal.btnLoading = true;
          //   选中了哪个方案
          util.ajax.post('/push/batchUpdatePushConfig', {
            deviceIds: this.batchPusherModal.selectedDevices,
            code: this.batchPusherModal.push_scheme_code  // 方案code
          }).then(res => {
            this.batchPusherModal.btnLoading = false;
            if (!res.code) {
              this.$Message.success(this.$t("l.success"));
              this.batchPusherModal.show = false;
            }
          })
        }
      })


    },

    addPushAccount(schemeRecord) {
      let label = schemeRecord.label;
      let config = JSON.stringify(schemeRecord.config);
      let port = schemeRecord.port;
      // 追加子账号
      schemeRecord.children.push({
        children: [],
        label: label,
        config: JSON.parse(config).map(e => {
          e.value = "";
          return e;
        }),
        describe: '',
        name: '',
        port,
      });
    },
    wuHanPusherConfig(p){
      let usernameItem = p.config.find(e => e.map_field === 'username');
      usernameItem.value = this.generateShortId()
      let passwordItem = p.config.find(e => e.map_field === 'password');
      passwordItem.value = this.generateShortId()
    },

    removeChildPusherConfig(index, item, parentItem) {
      parentItem.children.splice(index, 1);
    },

    // 自定义筛选时间
    selectedDate(values) {
      this.search.end_date_range.selected = values;
      this.loadData(1, this.search);
    },
    generateShortId() {
      const uuid = crypto.randomUUID();
      const hex = uuid.replace(/-/g, ''); // 移除横杠
      const base62Chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
      let shortId = '';

      // 将 16 进制转为 Base62
      let number = BigInt('0x' + hex);
      while (number > 0) {
        const remainder = Number(number % 62n);
        shortId = base62Chars[remainder] + shortId;
        number = number / 62n;
      }
      return shortId.padStart(22, '0'); // 补零至固定长度
    },

      // 2025年10月28日 王欢  加载所有电梯位置坐标点
    loadAllDeviceMapMarkers(){
      util.ajax.get('/device/allMapMarkers').then(res => {
        this.mapDrawer.markers = res.data;
        console.log(this.mapDrawer.markers);
      })
    },

  },
  activated() {
    let page = parseInt(sessionStorage.getItem('device-page') || '1');
    if (this.$route.params.search) this.search.device_state.selected.push(0);
    this.loadData(page, this.search);
    sessionStorage.removeItem('device-page');
  },
  mounted() {
    this.routeName = (this.$route || this._route).name;
    this.loadLikes();
    this.loadOptions();
    monitorUtil.setFaultListener(this.onRealtimeFault.bind(this), this.onRealtimeSolveFault.bind(this));
    monitorUtil.ws.on('status_report', this.onOnlineStatusMessage.bind(this), 1);
  },
  created() {
    // this.loadRegionData();
    ws.on("updateDeviceStatus", this.updateDeviceStatus.bind(this))
    // this.loadAllDeviceMapMarkers();
  },
  computed: {
    isZhongFuCompany(){
      let conmpany = this.$store.state.user.user.company;
      return conmpany.id === 154 || conmpany.pid === 154;
    },
    getRules() {
      return {
        'device.name': [{required: true, message: this.$t('l.remark33'), trigger: 'blur'}],
        totalFloor: [{validator: this.validateTotalFloor, trigger: 'blur'}],
      }
    },
    getColumns() {
      // 2025年10月28日 王欢 按照姜铎和闵总沟通后的要求将中富电梯的厂家代码显示全部替换成电梯唯一工号
      let conmpany = this.$store.state.user.user.company;
      let isZhongFuCompany = conmpany.id === 154 || conmpany.pid === 154;
      let list = [
        {
          title: this.$t('l.lift_name'),
          key: "name",
        },
        {
          title: isZhongFuCompany?this.$t('l.device_unique_id'):this.$t('l.device_number'),
          key: "code",
        },
        {
          title: this.$t('l.device_model'),
          key: "model",
        },
        {
          title: this.$t('l.terminal_id'),
          key: "terminal_id",
        },
        {
          title: this.$t('l.equipment_code'),
          key: "equipment_code",
        },
        {
          title: this.$t('l.device_unique_id'),
          key: "yd_unique_code",
        },
        {
          title: this.$t('l.community'),
          key: "community_id",
        },
        {
          title: this.$t('l.total_floor'),
          key: "j_floors",
        },
        {
          title: this.$t('l.brand'),
          key: "brand",
        },
        {
          title: this.$t('l.lift_factory'),
          key: "factory_cid",
        },
        {
          title: this.$t('l.alarm_mobile'),
          key: "j_alarm_charger",
        },
        {
          title: this.$t('l.through_door'),
          key: "is_through_door",
        },
        {
          title: this.$t('l.mt_company'),
          key: "mt_cid",
        },
        {
          title: this.$t('l.mt_person'),
          key: "j_mt_workers",
        },
        {
          title: this.$t('l.rated_speed'),
          key: "speed",
        },
        {
          title: this.$t('l.rated_load'),
          key: "load",
        },
        {
          title: this.$t('l.address'),
          key: "address",
        },
        {
          title: this.$t('l.m_remarker'),
          key: "remark",
        },
      ];
      let isROOT = this.$store.state.user.isROOT;
      if (!isROOT) {
        let index = list.findIndex(elem => elem.key === 'factory_cid');
        list.splice(index, 1);
      }
      return list;
    },

    getDeviceForPushColumns() {
      // 给 data 项设置特殊 key _checked: true 可以默认选中当前项。
      const list = [
        {
          type: 'selection',
          width: 55,
          align: 'center',
        },
        {
          title: this.$t('l.lift_name'),
          key: "name",
        },
        {
          title: this.isZhongFuCompany?this.$t('l.device_unique_id'):this.$t('l.device_number'),
          key: "code",
          width: 150,
        },
        {
          title: this.$t('l.device_model'),
          key: "model",
          width: 120,
        },
        {
          title: this.$t('l.terminal_id'),
          key: "terminal_id",
          width: 180,
        },
        {
          title: this.$t('l.address'),
          key: "address",
        },
        {
          title: this.$t('l.pusher_name'),
          key: "pusher_name",
          width: 180,
        },
      ];
      return list;
    },


    getData() {
      let list = [{
        name: 'xxxx电梯',
        yd_unique_code: '',
        code: '',
        model: '',
        iccid:"",
        terminal_id: '',
        equipment_code: '',
        is_through_door: 0,
        j_floors: 0,
        brand: '',
        community_id: '',
        mt_cid: 0,
        j_mt_workers: [],
        speed: 0,
        load: 0,
        ad_cid: 0,
        factory_cid: 0,
        j_alarm_charger: [],
        address: '',
        remark: '',
      }];
      let isROOT = this.$store.state.user.isROOT;
      if (!isROOT) {
        delete list[0].factory_cid;
      }
      // switch (myCompany.role_id) {
      //     // 如果是电梯厂
      //     case roleTypes.ELEV_FACTORY:
      //         if (myCompany.type == 0) { // 公司
      //             list[0].factory_cid = myCompany.id;
      //         } else {
      //             list[0].factory_cid = myCompany.pid;
      //         }
      //         break;
      //     case roleTypes.MT_COMPANY:
      //         list[0].mt_cid = myCompany.id;
      //         this.remoteSearchMTWorker(myCompany.id);
      //         break;
      // }
      return list;
    },
    getDeviceTypeList() {
      return [
        {id: 0, lable: this.$t('l.lift_type1')},
        {id: 1, lable: this.$t('l.lift_type2')},
        {id: 2, lable: this.$t('l.lift_type3')},
        {id: 3, lable: this.$t('l.lift_type4')},
      ]
    },
    // varietyList(){
    //   return  [
    //     {
    //       value: 1,
    //       label: this.$t('l.variety_type1')
    //     },
    //     {
    //       value: 2,
    //       label: this.$t('l.variety_type2')
    //     },
    //     {
    //       value: 3,
    //       label: this.$t('l.variety_type3')
    //     },
    //     {
    //       value: 4,
    //       label: this.$t('l.variety_type4')
    //     },
    //     {
    //       value: 5,
    //       label: this.$t('l.variety_type5')
    //     },
    //     {
    //       value: 6,
    //       label: this.$t('l.variety_type6')
    //     },
    //     {
    //       value: 7,
    //       label: this.$t('l.variety_type7')
    //     },
    //     {
    //       value: 8,
    //       label: this.$t('l.variety_type8')
    //     },
    //     {
    //       value: 9,
    //       label: this.$t('l.variety_type9')
    //     },
    //     {
    //       value: 10,
    //       label: this.$t('l.variety_type10')
    //     },
    //     {
    //       value: 11,
    //       label: this.$t('l.variety_type11')
    //     },
    //     {
    //       value: 12,
    //       label: this.$t('l.variety_type12')
    //     },
    //     {
    //       value: 13,
    //       label: this.$t('l.variety_type13')
    //     },
    //     {
    //       value: 14,
    //       label: this.$t('l.variety_type14')
    //     },
    //   ]
    // },


    communityMap() {
      let map = {};
      if (this.search.community_id.values) {
        this.search.community_id.values.forEach(comm => {
          comm.j_region = util.parseJSON(comm.j_region);
          map[comm.id] = comm;
        })
      }
      return map;
    },
    chargerMap() {
      let map = {};
      if (this.search.j_alarm_charger.values) {
        this.search.j_alarm_charger.values.forEach(charger => {
          map[charger.mobile] = charger;
        })
      }

      return map;
    },
    fzrMap() {
      let map = {};
      if (this.search.j_fzrs.values) {
        this.search.j_fzrs.values.forEach(fzr => {
          map[fzr.mobile] = fzr;
        })
      }
      return map;
    },
    mtWorkersMap() {
      let map = {};
      if (this.search.j_mt_woker.values) {
        this.search.j_mt_woker.values.forEach(mt => {
          map[mt.mobile] = mt;
        })
      }
      return map;
    },
    deviceMap() {
      let map = {};
      this.table.data.forEach(device => {
        if (device.terminal_id) {
          map[device.terminal_id] = device;
        } else {
          if (device.vm_device_id) map[device.vm_device_id] = device;
        }
      })
      return map;
    },
    showpush() {
      return (this.modal.device.terminal_id && !this.modal.device.terminal_id.startsWith("E"));
    },
    partsLifeMap() {
      return {};
    },
    showPushFiled() {
      // this.modal.filed_list
      return this.modal.filed_list.length && this.modal.device.terminal_id;
    },
  },
  watch: {
    '$route'(newRoute) {
      if (newRoute.name !== this.routeName) {
        monitorUtil.destroy(); // 跳转别的路由
      } else if (this.monitorList.showMonitor) {
        monitorUtil.refreshList(this.table.data);
      }
    },
    // 'table.loading': {
    //   handler(vn, ov) {
    //     if (vn) {
    //       this.$Message.loading({
    //         content: this.$t('l.hint46'),
    //         duration: 0
    //       })
    //     } else {
    //       this.$Message.destroy();
    //     }
    //   }
    // }
  },
  beforeDestroy() { // 页面销毁
    this.warnModal.show = false;
    monitorUtil.destroy();
    this.$Message.destroy();
  },
};

</script>

<style lang="less" scoped>

.unsubscribe {
  color: #cfcfcf;
}

.arrow {
  border: 1px #7fb0fe solid;
}

.ivu-form-item-content {
  margin-left: 0;
}

.screen-modal {
  max-height: 600px;
  overflow-y: auto;

  p {
    color: #8b8b8b;
    font-weight: bold;
    padding-bottom: 10px;
    margin-bottom: 5px;
  }
}

.community-drawer {
  width: 200px;
  height: 300px;
  border: 1px solid black;
  overflow: auto;
  position: absolute;
  right: 0;
  top: 134px;
  background-color: white;
}

/*批处理下拉菜单*/
.batchContainer {
  z-index: 9;
  min-height: 120px;
  max-height: 600px;
  background-color: white;
  overflow: hidden;
  overflow-y: auto;
  box-shadow: 0 0 5px #ddd;
  border-radius: 4px 0 4px 4px;
}

/*破批量处理按钮*/
.batchButton {
  overflow: hidden;
  float: left;
  position: relative;
  height: 32px;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
  padding: 6px 15px 5px;
  font-size: 12px;
  font-weight: 400;

  span {
    background-color: white;
    border-radius: 50%;
    width: 20px;
    font-size: 12px;
    display: inline-block;
    height: 20px;
  }
}

.batchButton:hover {
  background-color: #eaf2f8;
}

.batchButtonT {
  overflow: hidden;
  float: left;
  position: relative;
  height: 33px;
  z-index: 10;
  border-radius: 4px 4PX 0 0;
  text-align: center;
  background: white;
  cursor: pointer;
  box-sizing: border-box;
  padding: 6px 15px 5px;
  font-size: 12px;
  font-weight: 400;
  border-bottom: 0;

  span {
    background-color: white;
    border-radius: 50%;
    width: 20px;
    font-size: 12px;
    display: inline-block;
    height: 20px;
  }
}

.area-select {
  position: relative;
  height: 26px;
  border-radius: 4px;
  margin-left: 8px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  line-height: 25px;
  padding-left: 8px;
  padding-right: 8px;
  overflow: hidden;
  border: 1px solid #e3e4e5;
  float: left;
  top: 1px;
  background: #fff;
  cursor: pointer;
  margin-right: 8px;
  margin-bottom: 16px;
}

.area-selectT {
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 26px;
  line-height: 25px;
  padding-left: 8px;
  padding-right: 8px;
  overflow: hidden;
  border: 1px solid #e3e4e5;
  float: left;
  top: 1px;
  background: #fff;
  z-index: 10;
  border-bottom: 0;
  margin-left: 8px;
  margin-right: 8px;
  margin-bottom: 16px;
}

.area-container {
  margin-left: 8px;
  position: absolute;
  float: left;
  width: 450px;
  height: 200px;
  z-index: 9;
  border: 1px solid #e3e4e5;
  box-shadow: 0 0 5px #ddd;
  background-color: white;
  top: 126px;
  overflow-y: auto;
}

ul {
  overflow: hidden;
  zoom: 1
}

.community-container {
  max-height: 100px;
  overflow-y: auto;
}

a {
  color: #fff;
}

.download-xls {
  display: inline-block;
  font-size: 12px;
  height: 23px;
  width: 60px;
  text-align: center;
  vertical-align: middle;
  line-height: 23px;
  background: #3399ff;
  color: #fff;
  margin-left: 5px;
  text-decoration: none;
}

.download-xls:hover {
  opacity: .85;
  transition: opacity .2s;
  background-color: #33ccff;
  color: #fff;
}

.upload-button { // 上传按钮组件
  display: inline-block;
}

.floor-edit {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sample {
  width: 250px;
  height: 200px;
  color: #000;
  box-shadow: 0 0 5px #fff;
  padding: 0px;
  background: transparent;
}

.content-ellipsis1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title-userName {
  color: #008AEB;
  font-size: 15px;
  font-weight: normal;
  margin-left: 10px;
  font-size: 15px;
}

.innerTitle {
  height: 36px;
  display: flex;
  border-radius: 7px 7px 0px 0px;
  background-color: #F4F4F4;
  border-bottom: solid 1px #E7E7E7;
  display: flex;
  border-radius: 7px 7px 0px 0px;
}

.nowrap {
  width: 200px;
  line-height: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.iconfize {
  font-size: 25px;
}

.body-all {
  margin: 6px 15px;
  background-color: #E4EFF9;
  border-radius: 7px
}

.ul-all {
  margin-block-start: 0px;
  list-style-type: none;
  padding: 5px;
  margin-left: 10px;
  margin-bottom: 0px;
  padding: 5px;
}

.tonghua {
  cursor: pointer;
  margin-left: 15px;
  width: 50px;
  height: 35px;
}

.bm-local-search {
  width: 0px;
  display: none;
}

.filed-list {
  font-size: 14px;
  font-weight: 600;
}

/* 部件配置 */
.parts-label-ul {
  max-height: 500px;
  overflow-y: auto;
}

.parts-label-ul > li {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.parts-label-id {
  width: 5%;
}

.parts-label-ul > li > span {
  display: block;
  text-align: center;
  width: 30%;
  line-height: 30px;
  font-size: 14px;
}

.parts-label-title {
  font-size: 16px;
  font-weight: bold;
}

.to-setting-box {
  font-size: 16px;
}

.to-setting {
  color: #57a3f3;
  cursor: pointer;
  text-decoration: underline;
}

.view-change-box {
  display: flex;
  justify-content: end;

}

.view-change-box div:nth-child(1) img {
  width: 24px;
  cursor: pointer;

}

.view-change-box div:nth-child(2) img {
  width: 26px;
  margin-top: 1px;
  cursor: pointer;
}

.push-box {
  max-height: 600px;
  overflow-y: auto;
}

fieldset {
  padding: 10px;
  margin-top: 10px;
}

fieldset legend {
  padding: 0 10px;
  font-size: 16px;
  font-weight: 500;
}

.child-account-box {
  margin-left: 13px;
  padding: 10px;
  width: calc(100% - 130px);
  border: 1px dashed #b9b9b9;
  margin-top: 10px;
}

.push-file-box {
  max-width: 420px;
  white-space: nowrap;
  overflow-x: auto;
  margin-left: 5px;
}

.push-file-box::-webkit-scrollbar {
  height: 3px;
}
</style>